// Zachować kolejność alfabetyczną dodając nowe enum
// Enum powinien dokładnie odwzorowywać swój odpowiednik z pliku Enums.cs z projektu Common
// Jeśli istnieją uzasadnione przypadki, w których trzeba stworzyć enum lokalnie ma rozpoczynać się przedrostkiem Simax
// Enum'y poza modulem Enums są deprecated i powinny zostać sukcesywanie usuwane

// #region Enums

export module Enums {

    // #region ActionScheduleMode

    /**
     * IMR.Suite.Common.Enums.ActionScheduleMode
     * */
    export enum ActionScheduleMode {
        Normal = 0x00,
        ExecuteAtTime = 0x01,
        WaitForPacket = 0x02,
        WaitForData = 0x04,
        CalculateWakeUp = 0x08
    }

    // #endregion

    // #region ActionType

    /**
     * Nazwy typów akcji
     * */
    export class ActionType {
        public static OPEN_VALVE_SAFE: string = 'OPEN_VALVE_SAFE'
        public static CLOSE_VALVE: string = 'CLOSE_VALVE'
    }

    // #endregion

    // #region Alignment

    /**
     * IMR.Suite.Common.Alignment
     * */
    export enum Alignment {
        Unknown = 0,
        Center = 1,
        Left = 2,
        Top = 3,
        Right = 4,
        Bottom = 5,
        TopLeft = 6,
        TopRight = 7,
        BottomLeft = 8,
        BottomRight = 9
    }

    // #endregion

    // #region AuthenticationMode

    /**
     * IMR.Suite.Common.Enums.ActionScheduleMode
     * */
    export enum AuthenticationMode {
        Standard = 0,
        Domain = 1,
        SimpleDomain = 2
    }

    // #endregion

    // #region Browsers

    /**
     * 
     * */
    export enum Browsers {
        Chrome = 1,
        Safari = 2,
        Firefox = 3,
        MicrosoftEdge = 4,
        InternetExplorer = 5,
        Opera = 6
    }

    // #endregion

    // #region ChartType

    /**
     * IMR.Suite.Common.Enums.ChartType
     * */
    export enum ChartType {
        Bar = 0,
        StackedBar = 1,
        FullStackedBar = 2,
        SideBySideStackedBar = 3,
        SideBySideFullStackedBar = 4,
        Pie = 5,
        Doughnut = 6,
        NestedDoughnut = 7,
        Funnel = 8,
        Point = 9,
        Bubble = 10,
        Line = 11,
        StackedLine = 12,
        FullStackedLine = 13,
        StepLine = 14,
        Spline = 15,
        ScatterLine = 16,
        SwiftPlot = 17,
        Area = 18,
        StepArea = 19,
        SplineArea = 20,
        StackedArea = 21,
        StackedStepArea = 22,
        StackedSplineArea = 23,
        FullStackedArea = 24,
        FullStackedSplineArea = 25,
        FullStackedStepArea = 26,
        RangeArea = 27,
        Stock = 28,
        CandleStick = 29,
        SideBySideRangeBar = 30,
        RangeBar = 31,
        SideBySideGantt = 32,
        Gantt = 33,
        PolarPoint = 34,
        PolarLine = 35,
        ScatterPolarLine = 36,
        PolarArea = 37,
        PolarRangeArea = 38,
        RadarPoint = 39,
        RadarLine = 40,
        ScatterRadarLine = 41,
        RadarArea = 42,
        RadarRangeArea = 43,
        Bar3D = 44,
        StackedBar3D = 45,
        FullStackedBar3D = 46,
        ManhattanBar = 47,
        SideBySideStackedBar3D = 48,
        SideBySideFullStackedBar3D = 49,
        Pie3D = 50,
        Doughnut3D = 51,
        Funnel3D = 52,
        Line3D = 53,
        StackedLine3D = 54,
        FullStackedLine3D = 55,
        StepLine3D = 56,
        Area3D = 57,
        StackedArea3D = 58,
        FullStackedArea3D = 59,
        StepArea3D = 60,
        Spline3D = 61,
        SplineArea3D = 62,
        StackedSplineArea3D = 63,
        FullStackedSplineArea3D = 64,
        RangeArea3D = 65
    }

    // #endregion

    // #region CommandCode

    /**
     * IMR.Suite.Common.Enums.CommandCode
     * */
    export enum CommandCode {
        COMMAND_ID_NONE = 0,
        COMMAND_ID_FORCE_RADIO433_FRAME = 1,
        COMMAND_ID_FORCE_RADIO869_FRAME = 2,
        COMMAND_ID_PERIODIC_ARCHIVE_SAVE = 4,
        COMMAND_ID_MONTHLONG_ARCHIVE_SAVE = 5,
        COMMAND_ID_READ_TEMPERATURE = 6,
        COMMAND_ID_OPTO_ON = 7,
        COMMAND_ID_SET_TIME = 16,
        COMMAND_ID_DEVICE_RESET = 17,
        COMMAND_ID_OPTO_OFF = 18,
        COMMAND_ID_DIRECT_ACCESS = 19,
        COMMAND_ID_TEMPORARY_GE_ON = 20,
        COMMAND_ID_PACKET_ARCHIVE_CLEAR = 21,
        COMMAND_ID_DIAGNOSTICS_CLEAR = 22,
        COMMAND_ID_DAYLONG_ARCHIVE_CLEAR = 32,
        COMMAND_ID_DEFAULT_CONFIGURATION = 33,
        COMMAND_ID_LCD_OFF = 34,
        COMMAND_ID_SET_CARRIER = 35,
        COMMAND_ID_SET_OFTEN_FRAME433 = 36,
        COMMAND_ID_CLEAR_OFTEN_FRAME433 = 37,
        COMMAND_ID_AIR_RADIO_LEVEL_TEST = 38,
        COMMAND_ID_SET_OFTEN_FRAME869 = 39,
        COMMAND_ID_CLEAR_OFTEN_FRAME869 = 40,
        COMMAND_ID_LOG_WRITE = 41,
        COMMAND_ID_2ND_COUNTER_START = 42,
        COMMAND_ID_2ND_COUNTER_STOP = 43,
        COMMAND_ID_RAPID_HANDLE = 44,
        COMMAND_ID_LATEST_SACK_ARCHIVE = 45,
        COMMAND_ID_WAKEUP_GSM = 48,
        COMMAND_ID_OPTO_LOG = 49,
        COMMAND_ID_FREQ = 50,
        COMMAND_ID_WAKEUP_RADIO = 51,
        COMMAND_ID_GSM_TEST = 52,
        COMMAND_ID_GSM_RESET = 53,
        COMMAND_ID_DEVICE_STATUS_CLEAR = 54,
        COMMAND_ID_SACK_FREQ = 55,
        COMMAND_ID_MULTIREAD_FREQ = 56,
        COMMAND_ID_GSM_SHUTDOWN = 57,
        COMMAND_ID_GET_REQUEST = 58,
        COMMAND_ID_TEMPORARY_GE_OFF = 59,
        COMMAND_ID_ANALOG_ARCHIVE_FREQ = 60,
        COMMAND_ID_SACK_UNIQUE_FREQ = 61,
        COMMAND_ID_SEND_FRAMES_FROM_FLASH = 62,
        COMMAND_ID_SACK_KNOWN_NODES = 63,
        COMMAND_ID_INSTALL = 64,
        COMMAND_ID_UNINSTALL = 65,
        COMMAND_ID_WAIT_FOR_SEAL = 66,
        COMMAND_ID_FULL_INSTALLATION = 67,
        COMMAND_ID_SEAL = 68,
        COMMAND_ID_REFLASH_DEVICE = 69,
        COMMAND_ID_ANALOG_ARCHIVE_SAVE = 70,
        COMMAND_ID_ANALOG_ARCHIVE_CLEAR = 71,
        COMMAND_ID_ANALOG_ARCHIVE_LATCH = 72,
        COMMAND_ID_DIFF_COPY = 73,
        COMMAND_ID_WAKEUP_GPS = 74,
        COMMAND_ID_ERASE_FLASH = 75,
        COMMAND_ID_ERASE_SACK = 76,
        COMMAND_ID_SACK_ARCHIVE = 77,
        COMMAND_ID_LON_RESET = 78,
        COMMAND_ID_REFLASH_INIT = 79,
        COMMAND_ID_I2C_FORCE_MEASUREMENT = 80,
        COMMAND_ID_WMBUS_SEND_UD2 = 81,
        COMMAND_ID_MAGNETO_COUNTERS_RESET = 82,
        COMMAND_ID_GET_DIAGNOSTICS = 83,
        COMMAND_ID_GET_OMB = 84,
        COMMAND_ID_PREPAID_TEST = 95,
        COMMAND_ID_PREPAID_COMMISSION = 96,
        COMMAND_ID_PREPAID_DECOMMISSION = 97,
        COMMAND_ID_PREPAID_EC_CONF = 98,
        COMMAND_ID_WMBUS_MODE_NORMAL = 99,
        COMMAND_ID_WMBUS_MODE_TEMPORAL = 100,
        COMMAND_ID_WALK_BY_FRAME = 101,
        COMMAND_ID_VALVE_OPEN_UNSAFE = 102,
        COMMAND_ID_VALVE_CLOSE_UNSAFE = 103,
        COMMAND_ID_RADIO_RESET = 104,
        COMMAND_ID_STATIONARY_FRAME = 105,
        COMMAND_ID_PREPAID_RESUME = 106,
        COMMAND_ID_UDI_RESET = 107,
        COMMAND_ID_PREPAID_SUSPEND = 108,
        COMMAND_ID_CLEAR_R2S_TABLE = 109,
        COMMAND_ID_DIFF_READ = 110,
        COMMAND_ID_LCD_SET_ALL = 111,
        COMMAND_ID_EVC = 112,
        COMMAND_ID_ANALOG_LOG_ARCHIVE_CLEAR = 113,
        COMMAND_ID_SEND_TEXT_SMS = 114,
        COMMAND_ID_VALVE_CLOSE_SAFE = 115,
        COMMAND_ID_VALVE_OPEN_CONFIRM = 116,
        COMMAND_ID_VALVE_OPEN_SAFE = 117,
        COMMAND_ID_SEND_RADIO_SYNC_FRAME = 118,
        COMMAND_ID_REGULATOR_FREQ = 119,
        COMMAND_ID_LAN3_QUERY_SLAVE = 120,
        COMMAND_ID_DANFOSS_REQUEST = 121,
        COMMAND_ID_RADIO_PROTOCOL_MODE = 122,
        COMMAND_ID_LAN3_CLEAR_KNOWN_NODES = 123,
        COMMAND_ID_MODBUS_REQUEST = 124,
        COMMAND_ID_MODBUS_DATA_TYPE_REQUEST = 125,
        COMMAND_ID_RADIO_SEND_RADIAN_REQUEST = 126,
        COMMAND_ID_LAN3_SEND_SACK_UNIQUE = 127,
        COMMAND_ID_RADIO_REFLASH_PROCEDURE = 128,
        COMMAND_ID_KNOW_NODES_QUERY = 129,
        COMMAND_ID_RADIO_SEND_WAVENIS_REQUEST = 130,
        COMMAND_ID_CANCEL_LOADED_FV_MSG = 131,
        COMMAND_ID_CHECK_CONDITION_TANKING = 132,
        COMMAND_ID_ARCHIVE_TIME_BACK_QUERY = 133,
        COMMAND_ID_HEATMETER_READOUT = 0x86, // 134
        COMMAND_ID_GET_CHARACTERISTICS = 0x87,  //  135
        COMMAND_ID_SIGFOX_SEND = 0x88,  //  136
        COMMAND_ID_LCD_WARNING_ICON_CLEAR = 137,
        COMMAND_ID_READ_BATTERY_VOLTAGE = 0x8A, // 138
        COMMAND_ID_PACKET_ARCHIVE_RESEND = 0x8B, // 139
        COMMAND_ID_LORA_SEND = 0x8C, // 140 // z minor
        COMMAND_ID_LORA_LINK_CHECK_REQUEST = 0x8D, // 141 // z minor
        COMMAND_ID_CALIBRATE_INDUCTIVE_SENSOR = 0x8E, // 142 // z minor
        COMMAND_ID_TEMPERATURE_SENSOR_I2C_REQUEST = 0x8F, // 143
        COMMAND_ID_CURRENT_LOOP_REQUEST = 0x90, // 144
        COMMAND_ID_MAGNETIC_SENSOR_REQUEST = 0x91, // 145
        COMMAND_ID_UDI_SET_OUTPUT = 0x92, // 146
        COMMAND_ID_ACO_CALIBRATION = 0x94, // 148
        COMMAND_ID_DEVICE_RESET2 = 77717,
        COMMAND_ID_DEVICE_RESET3 = 77817,
    }

    // #endregion

    // #region ConsumerTransactionType

    /**
     * IMR.Suite.Common.Enums.ConsumerTransactionType
     * */
    export enum ConsumerTransactionType {
        Consumption = 1,
        DeliveryCharge = 2,
        StandingCharge = 3,
        CarbonTax = 4,
        TopUp = 5,
        Refund = 6,
        Manual = 7,
        MonthlyAdditionalCharge = 8,
        EmergencyCreditPrepayment = 9,
        EmergencyCreditFetch = 10,
        OpenValve = 11,
        CloseValve = 12,
        EmergencyCreditSettlement = 13,
        OwedValueUpdate = 14
    }

    // #endregion

    // #region DatabaseType

    /**
     * IMR.Suite.Common.Enums.DatabaseType
     * */
    export enum DatabaseType {
        Unknown = 0,
        CORE = 1,
        DAQ = 2,
        DW = 3,
        CORE_IMRSC = 4
    }

    // #endregion

    // #region DashboardCorrelationType

    /**
     * IMR.Suite.Common.Enums.DashboardCorrelationType
     * */
    export enum DashboardCorrelationType {
        None = 0,
        Local = 1,
        Server = 2,
    }

    // #endregion

    // #region DataStatus

    /**
     * IMR.Suite.Common.Enums.DataStatus
     * */
    export enum DataStatus {
        Unknown = 0,
        Normal = 0x01,
        DuringRefuelling = 0x02,
        ActiveInDevice = 0x04,
        TemperatureError = 0x08,
        Predicted = 0x10,
        Synchronized = 0x20,
        Outlier = 0x40,
        Doublet = 0x4000000000000000
    }

    // #endregion

    // #region DataType

    /**
     * IMR.Suite.Common.DataType
     * */
    export enum DataType {
        //Location
        LOCATION_NAME = 1,       // Nazwa
        LOCATION_CITY = 2,         // Miejscowość
        LOCATION_ADDRESS = 3,         // Adres
        LOCATION_ZIP = 4,         // Kod pocztowy
        LOCATION_COUNTRY = 5,         // Kraj
        LOCATION_CID = 6,         // CID
        LOCATION_LATITUDE = 7,         // Szerokość geograficzna
        LOCATION_LONGITUDE = 8,         // Długość geograficzna
        LOCATION_CREATION_DATE = 9,         // Data utworzenia
        LOCATION_MEMO = 10,        // Notatki
        LOCATON_LAST_MAINTENANCE_DATE = 11,        // Ostatni serwis
        LOCATION_CONTACT_PHONE_1 = 12,        // Telefon kontaktowy 1
        LOCATION_CONTACT_PHONE_2 = 13,        // Telefon kontaktowy 2
        LOCATION_CONTACT_PHONE_3 = 14,        // Telefon kontaktowy 3
        LOCATION_RESTRICTIONS = 15,        // Restrykcje na lokalizacji
        LOCATION_IS_INITIALIZED = 16,        // Czy lokalizacja zainicjalizowana?
        LOCATION_IS_EQUIPPED = 17,        // Czy na lokalizacji znajdują sie urządzenia telemetryczne?
        LOCATION_IS_ACTIVE = 18,        // Czy lokalizacja jest aktywna?
        LOCATION_IS_RUNNING = 19,        // Czy lokalizacja jest działająca?

        LOCATION_STATE_TYPE_NOTE = 192, // Notatka statusu lokalizacji

        LOCATION_WARRANTY_DATE = 211,
        LOCATION_INSTALLATION_CATEGORY = 216,

        //Depository
        LOCATION_DEPOSITORY_MIN_STATE_ELEMENT_TYPE = 217, // reference type idArticle
        LOCATION_DEPOSITORY_MIN_STATE_ELEMENT_AMOUNT = 218,

        LOCATION_INVOICE_REQUEST_ENABLED = 219,

        //Device
        DEVICE_FACTORY_NUMBER = 1001,       // Produkcyjny numer seryjny urządzenia
        DEVICE_HARDWARE_VERSION = 1002,       // 
        DEVICE_BATTERY_VERSION = 1003,       // 
        DEVICE_CONFIGURATION_CREATION_DATE = 1004,       // 
        DEVICE_BATTERY_CHANGE_DATE = 1005,       // 
        DEVICE_FIRMWARE_CHANGE_DATE = 1006,       //
        DEVICE_LONG_ANTENNA = 1007,       // 
        DEVICE_ESTIMATED_DEAD_DATE = 1008,       // 
        DEVICE_NCAB = 1009,       // 
        DEVICE_PHONE_NUMBER = 1010,      // <Brak opisu>
        DEVICE_APN_IP = 1011,      // <Brak opisu>
        DEVICE_APN_PORT = 1012,      // <Brak opisu>
        DEVICE_PACKAGE_NBR = 1013,      // <Brak opisu>
        DEVICE_DRIVER = 1014,      // <Brak opisu>
        DEVICE_WARRANTY_DATE = 1015,

        METER_SERIAL_NUMBER = 2006,

        OPERATOR_EMAIL_NOTIFICATION_OPTIONS_ISSUE = 3821,
        OPERATOR_EMAIL_NOTIFICATION_OPTIONS_TASK = 3822,
        OPERATOR_EMAIL_NOTIFICATION_OPTIONS_ROUTE = 3823,
        OPERATOR_EMAIL_NOTIFICATION_OPTIONS_SHIPPING_LIST_CLOSE = 3902,
        OPERATOR_EMAIL_NOTIFICATION_OPTIONS_PACKAGE = 3910,
        OPERATOR_EMAIL_NOTIFICATION_OPTIONS_TASK_ID_DISTRIBUTOR = 3916,
        OPERATOR_EMAIL_NOTIFICATION_OPTIONS_ISSUE_ID_DISTRIBUTOR = 3917,
        OPERATOR_EMAIL_NOTIFICATION_OPTIONS_LOCATION = 3943,
        OPERATOR_EMAIL_NOTIFICATION_OPTIONS_LOCATION_ID_DISTRIBUTOR = 3944,
        OPERATOR_SMS_NOTIFICATION_OPTIONS_ISSUE = 3945,
        OPERATOR_SMS_NOTIFICATION_OPTIONS_TASK = 3946,
        OPERATOR_SMS_NOTIFICATION_OPTIONS_ROUTE = 3947,
        OPERATOR_SMS_NOTIFICATION_OPTIONS_PACKAGE = 3948,
        OPERATOR_SMS_NOTIFICATION_OPTIONS_LOCATION = 3949,
        OPERATOR_SMS_NOTIFICATION_OPTIONS_LOCATION_ID_DISTRIBUTOR = 3950,
        OPERATOR_SMS_NOTIFICATION_OPTIONS_TASK_ID_DISTRIBUTOR = 3951,
        OPERATOR_SMS_NOTIFICATION_OPTIONS_ISSUE_ID_DISTRIBUTOR = 3952,
        OPERATOR_SMS_NOTIFICATION_OPTIONS_SHIPPING_LIST_CLOSE = 3953,
        OPERATOR_EMAIL_NOTIFICATION_OPTIONS_ISSUE_ID_ISSUE_TYPE = 3961,
        OPERATOR_SMS_NOTIFICATION_OPTIONS_ISSUE_ID_ISSUE_TYPE = 3962,
        // Operator
        OPERATOR_IS_PREMIUM = 4012,
        OPERATOR_FITTER_NUMBER = 4013,

        OPERATOR_EMAIL_NOTIFICATION_OPTIONS_PACKAGE_ID_DISTRIBUTOR = 4032,

        ACTION_SCHEDULE_TIME = 6031,
        ACTION_SCHEDULE_MODE = 6032,
        ACTION_NOTE = 6155,

        //Other
        PATTERN_NAME = 10001,     // <Brak opisu>
        HELPER_ID_LOCATION = 10002,
        HELPER_ID_METER = 10003,
        HELPER_SERIAL_NBR = 10004,
        HELPER_ID_DISTRIBUTOR = 10005,
        HELPER_ID_CONSUMER = 10006,
        HELPER_ID_LOCATION_TYPE = 10007,
        HELPER_ID_LOCATION_STATE_TYPE = 10008,
        HELPER_LOCATION_IN_KPI = 10009,
        HELPER_LOCATION_ALLOW_GROUPING = 10010,
        GOOGLE_MAP_URL = 10011,
        GOOGLE_MAP_LATITUDE = 10012,
        GOOGLE_MAP_LONGITUDE = 10013,
        GOOGLE_MAP_ZOOM = 10014,
        HELPER_ID_DEVICE_TYPE = 10015,
        HELPER_ID_DEVICE_STATE_TYPE = 10016,
        HELPER_ID_DEVICE_ORDER_NUMBER = 10017,
        HELPER_ID_METER_TYPE = 10018,
        HELPER_DEVICE_TEMPLATE = 10019,
        PROFILE_ID = 10020, // id profilu przypisywane do distributor/location/meter/device
        TEMPORAL_START_TIME = 10021,
        TEMPORAL_END_TIME = 10022,
        TEMPORAL_ID_AGGREGATION_TYPE = 10023,
        DATA_FORMAT_GROUP_ID = 10024,
        HELPER_ID_METER_TYPE_CLASS = 10025,

        SGM_GROUPING_LOCATION_TYPE_NAME = 10026,
        SGM_GROUPING_LOCATION_TYPE_IS_ENABLED = 10027,

        HELPER_INSTALLATION_DATE = 10028,
        HELPER_LOCATION_PARENT_GROUPS = 10029,
        TEMPORAL_ID_DATA_SOURCE = 10030,
        HELPER_ID_TASK = 10031,
        HELPER_ID_OPERATOR = 10032,
        HELPER_ID_ISSUE = 10033,

        FAILED_LOGIN_RETRY_COUNT = 10034,
        FAILED_LOGIN_BLOCK_TIME = 10035,
        FAILED_LOGIN_RETRY_CHECK_TIME = 10036,
        LOG_OPERATOR_LOGIN_IN_SESSION = 10037,

        PASSWORD_MIN_LENGTH = 10038,
        PASSWORD_MIN_UPPER_LETTERS_COUNT = 10039,
        PASSWORD_MIN_LOWER_LETTERS_COUNT = 10040,
        PASSWORD_MIN_DIGITS_COUNT = 10041,
        PASSWORD_MIN_SPECIAL_SYMBOLS_COUNT = 10042,

        GENERATE_OPERATOR_PASSWORD_SALT = 10043,

        PASSWORD_VALIDITY_DAYS = 10044,

        HELPER_ID_ACTOR = 10045,

        PASSWORD_EXPIRY_NOTIFICATION_DAYS = 10046,

        HELPER_LOGIN = 10047,
        HELPER_PASSWORD = 10049,
        HELPER_IS_BLOCKED = 10050,

        FAILED_LOGIN_BLOCKED_TO_TIME_RETRY_COUNT = 10052,

        HELPER_ID_TASK_GROUP = 10053,
        HELPER_ID_PLANNED_ROUTE = 10054,
        HELPER_ID_OPERATOR_REGISTERING = 10055,
        HELPER_ID_OPERATOR_PERFORMER = 10056,
        HELPER_ID_TASK_STATUS = 10057,
        HELPER_CREATION_DATE = 10058,
        HELPER_ACCEPTED = 10059,
        HELPER_ID_OPERATOR_ACCEPTED = 10060,
        HELPER_ACCEPTANCE_DATE = 10061,
        HELPER_NOTES = 10062,
        HELPER_DEADLINE = 10063,
        HELPER_TOPIC_NUMBER = 10064,
        HELPER_PRIORITY = 10065,
        HELPER_OPERATION_CODE = 10066,
        HELPER_ID_TASK_TYPE = 10067,

        LAST_MEASURE_RANGE_TIME_COLOR = 10068,

        HELPER_ID_ISSUE_TYPE = 10069,
        HELPER_ID_ISSUE_STATUS = 10070,
        HELPER_REALIZATION_DATE = 10071,
        HELPER_SHORT_DESCR = 10072,
        HELPER_LONG_DESCR = 10073,

        HELPER_NAME = 10074,
        HELPER_SURNAME = 10075,
        HELPER_CITY = 10076,
        HELPER_ADDRESS = 10077,
        HELPER_POSTCODE = 10078,
        HELPER_EMAIL = 10079,
        HELPER_MOBILE = 10080,
        HELPER_PHONE = 10081,
        HELPER_ID_LANGUAGE = 10082,
        HELPER_DESCRIPTION = 10083,
        HELPER_AVATAR = 10084,

        LOCATION_VIEWER_ALL_INSTALLED_METERS_CHECKED = 10085,

        HELPER_ID_DESCR = 10086,

        LOGIN_AUTOFILL_DISABLED = 10087,

        LAYOUT_ID_FILE = 10088,

        HELPER_ID_IMR_SERVER = 10089,

        HELPER_ID_ALARM = 10090,
        HELPER_ID_ALARM_EVENT = 10091,
        HELPER_ID_ALARM_GROUP = 10092,
        HELPER_ID_ALARM_STATUS = 10093,
        HELPER_ID_TRANSMISSION_TYPE = 10094,

        HELPER_ID_ROUTE = 10095,
        HELPER_ID_ROUTE_DEF = 10096,
        HELPER_YEAR = 10097,
        HELPER_MONTH = 10098,
        HELPER_WEEK = 10099,
        HELPER_ID_OPERATOR_EXECUTOR = 10100,
        HELPER_ID_OPERATOR_APPROVED = 10101,
        HELPER_DATE_UPLOADED = 10102,
        HELPER_DATE_APPROVED = 10103,
        HELPER_DATE_FINISHED = 10104,
        HELPER_ID_ROUTE_STATUS = 10105,
        HELPER_ID_ROUTE_TYPE = 10106,
        HELPER_EXPIRATION_DATE = 10107,
        HELPER_ID_ALARM_DEF = 10108,
        HELPER_ID_DATA_ARCH = 10109,
        HELPER_IS_ACTIVE = 10110,

        HELPER_ID_ALARM_TYPE = 10111,
        HELPER_ID_DATA_TYPE_ALARM = 10112,
        HELPER_SYSTEM_ALARM_VALUE = 10113,
        HELPER_ALARM_VALUE = 10114,
        HELPER_TRANSMISSION_TYPE = 10115,

        HELPER_DISTRIBUTOR_ID_ROLE = 10116,

        HELPER_ID_REPORT = 10117,
        HELPER_ID_REPORT_TYPE = 10118,

        HELPER_ID_ACTION = 10119,
        HELPER_ID_ACTION_TYPE = 10120,
        HELPER_ID_ACTION_STATUS = 10121,
        HELPER_ID_ACTION_DATA = 10122,
        HELPER_ID_ACTION_PARENT = 10123,
        HELPER_ID_MODULE = 10124,

        HELPER_ID_ACTOR_GROUP = 10125,
        HELPER_BUILT_IN = 10126,

        HELPER_ACTION_HIERARCHY = 10127,
        HELPER_ACTION_HIERARCHY_LEVEL = 10128,
        HELPER_ACTION_HIERARCHY_ROOT = 10129,

        HELPER_SERIAL_NBR_PARENT = 10130,
        HELPER_TIME = 10131,
        HELPER_ALARM_MESSAGE = 10132,
        HELPER_IS_CONFIRMED = 10133,
        HELPER_CONFIRMED_BY = 10134,
        HELPER_CONFIRM_TIME = 10135,

        HELPER_DEVICE_HIERARCHY = 10136,
        HELPER_DEVICE_HIERARCHY_LEVEL = 10137,
        HELPER_DEVICE_HIERARCHY_ROOT = 10138,

        LDAP_PATH = 10139,
        LDAP_LOGIN = 10140,
        LDAP_PASSWORD = 10141,

        WESB_PROVIDER_HOST = 10142,
        WESB_PROVIDER_USERNAME = 10143,
        WESB_PROVIDER_PASSWORD = 10144,
        WESB_PROVIDER_IS_TEST_HOST = 10145,

        HELPER_IS_ENABLED = 10146,
        HELPER_DICTIONARY_COMPLETENESS = 10147,

        HELPER_ID_LOCATION_PATTERN = 10148,
        HELPER_SERIAL_NBR_PATTERN = 10149,
        HELPER_ID_METER_PATTERN = 10150,

        DASHBOARD_GRID_EXPORT_OPTION_VISIBLE = 10151,

        DASHBOARD_TILE_TEXT_HEADER = 10152,
        DASHBOARD_TILE_BACKGROUND_COLOR = 10153,
        DASHBOARD_TILE_HOVER_COLOR = 10154,
        DASHBOARD_TILE_SELECT_COLOR = 10155,
        DASHBOARD_TILE_AMOUNT_VISIBLE = 10156,
        DASHBOARD_TILE_TEXT_HEADER_VISIBLE = 10157,
        DASHBOARD_TILE_ICON_VISIBLE = 10158,
        DASHBOARD_TILE_ICON_ID_FILE = 10159,
        DASHBOARD_TILE_BACKGROUND_IMAGE_ID_FILE = 10160,

        DASHBOARD_GAUGE_MIN_VALUE = 10161,
        DASHBOARD_GAUGE_MAX_VALUE = 10162,
        DASHBOARD_GAUGE_TEXT_HEADER = 10163,
        DASHBOARD_GAUGE_RANGE_MIN_VALUE = 10164,
        DASHBOARD_GAUGE_RANGE_MAX_VALUE = 10165,
        DASHBOARD_GAUGE_RANGE_NAME = 10166,
        DASHBOARD_GAUGE_RANGE_COLOR = 10167,

        DASHBOARD_CHART_TITLE = 10168,
        DASHBOARD_CHART_SERIES_X_NAME = 10169,
        DASHBOARD_CHART_SERIES_Y_NAME = 10170,
        DASHBOARD_CHART_SERIES_X_CAPTION = 10171,
        DASHBOARD_CHART_SERIES_Y_CAPTION = 10172,
        DASHBOARD_CHART_SERIES_X_TYPE = 10173,
        DASHBOARD_CHART_SERIES_Y_TYPE = 10174,
        DASHBOARD_CHART_SERIES_NAME = 10175,
        DASHBOARD_CHART_SERIES_TYPE = 10176,
        DASHBOARD_CHART_SERIES_COLOR = 10177,
        DASHBOARD_CHART_SERIES_REFERENCE_TYPE = 10178,
        DASHBOARD_CHART_SERIES_X_FORMAT_DATA_TYPE = 10179,
        DASHBOARD_CHART_SERIES_Y_FORMAT_DATA_TYPE = 10180,

        DASHBOARD_GRID_COLUMN_NAME = 10181,
        DASHBOARD_GRID_COLUMN_CAPTION = 10182,
        DASHBOARD_GRID_COLUMN_TYPE = 10183,

        DASHBOARD_CARD_HEADER = 10184,
        DASHBOARD_CARD_TEXT = 10185,
        DASHBOARD_CARD_IMAGE_ID_FILE = 10186,
        DASHBOARD_CARD_BACKGROUND_COLOR = 10187,

        DASHBOARD_SCHEMA_REFERENCE_TYPE = 10188,
        DASHBOARD_SCHEMA_REFERENCE_VALUE = 10189,

        DASHBOARD_MAP_LEGEND_DESCRIPTION = 10190,
        DASHBOARD_MAP_LEGEND_COLOR = 10191,
        DASHBOARD_MAP_LEGEND_ICON_ID_FILE = 10192,

        HELPER_TANK_COUNT = 10193,

        DWSR_LOSS_TH_LITER = 10193,
        DWSR_LOSS_TH_PERCENTAGE = 10194,

        DASHBOARD_INDICATOR_IS_CUSTOMIZABLE = 10195,

        DASHBOARD_CARD_REFERENCE_TYPE = 10196,
        DASHBOARD_CARD_REFERENCE_VALUE = 10197,

        HELPER_ALARM_TIME = 10198,

        DASHBOARD_CHART_SERIES_CAPTION = 10199,

        HELPER_LOCATION_AREAS = 10200,

        DASHBOARD_TEMPLATE_DATABASE_TYPE = 10201,

        HELPER_ACTION_ID_LOCATION = 10202,
        HELPER_ACTION_ID_METER = 10203,
        HELPER_ACTION_SERIAL_NBR = 10204,
        HELPER_ACTION_TARGET = 10205,

        GOOGLE_MAP_ZOOM_DEFAULT = 10206,

        DASHBOARD_TILE_SHADOW_HORIZONTAL_LENGHT = 10207,
        DASHBOARD_TILE_SHADOW_VERTIVAL_LENGHT = 10208,
        DASHBOARD_TILE_SHADOW_BLUR_RADIUS = 10209,
        DASHBOARD_TILE_SHADOW_SPREAD_RADIUS = 10210,
        DASHBOARD_TILE_SHADOW_COLOR = 10211,
        DASHBOARD_TILE_BORDER_RADIUS = 10212,
        DASHBOARD_TILE_BORDER_WIDTH = 10213,
        DASHBOARD_TILE_BORDER_COLOR = 10214,

        HELPER_TANK_LEVEL_MIN = 10215,

        HELPER_ID_UNIT = 10216,
        HELPER_INDEX_NBR = 10217,
        HELPER_VALUE = 10218,
        HELPER_ID_DATA_TYPE = 10219,

        LOCATION_ACTIVITY = 10220,
        LOCATION_INACTIVITY = 10221,

        DATA_TYPE_DEFAULT_ID_DATA_TYPE = 10222,
        DATA_TYPE_DEFAULT_VALUE = 10223,

        DSS_DATA_ENTRY_SOURCE_QUEUE_PATH = 10224,
        DSS_DATA_ENTRY_RESEND_SOURCE_QUEUE_PATH = 10225,
        DSS_DATA_ENTRY_RESEND_ENVELOPE_QUEUE_PATH = 10226,
        DSS_ENVELOPE_MESSAGE_SOURCE = 10227,
        DSS_ENVELOPE_MESSAGE_DESTINATION = 10228,
        HELPER_ID_VIEW = 10229,

        DASHBOARD_GRID_COLUMN_FORMAT_DATA_TYPE = 10230,
        DASHBOARD_GRID_COLUMN_TOOLTIP = 10231,

        DASHBOARD_GRID_HEADER_TEXT_ALIGN = 10232,
        DASHBOARD_GRID_CONTEXT_MENU_ENABLED = 10233,

        ALLOW_CREATE_LOCATION_ON_REGISTRATION = 10234,
        IMR_SERVER_SMS_NOTIFIER_OPERATOR = 10235,
        IMR_SERVER_SMS_NOTIFIER_ID_ACTION_TYPE = 10236,

        DASHBOARD_GRID_SHORT_DETAILS_ENABLED = 10237,
        DASHBOARD_MAP_SHORT_DETAILS_ENABLED = 10238,

        DASHBOARD_GRID_PLAN_DELIVERY_OPTION_VISIBLE = 10239,
        DASHBOARD_GRID_PROBLEM_CONFIRMATION_OPTION_VISIBLE = 10240,

        DASHBOARD_CORRELATION_TYPE = 10241,

        KEEPER_ID_OPERATOR = 10242,
        DASHBOARD_CARD_OPTION = 10243,

        LOCATION_SCHEMA_TYPE = 10244,

        HELPER_LPG_OLDEST_LAST_MEASURE_TIME = 10245,

        HELPER_CELL_COLOR = 10246,

        HELPER_START_TIME = 10247,
        HELPER_END_TIME = 10248,
        HELPER_IS_READY_FOR_PREPAID = 10249,

        HELPER_ID_DISTRIBUTOR_HIERARCHY = 10250,

        GROUPING_LOCATION_TYPE_ID = 10251,
        GROUPING_LOCATION_TYPE_NAME = 10252,
        GROUPING_LOCATION_TYPE_IS_ENABLED = 10253,

        EXPORT_MEASUREMENT_MONTH = 10270,
        EXPORT_MEASUREMENT_YEAR = 10271,

        DASHBOARD_DX_PATH = 10276,
        DASHBOARD_DX_TOKEN = 10281,
        DASHBOARD_DX_MULTI_SOURCE_PATH = 10301,

        HELPER_REMOVED = 10302,

        HELPER_ID_OPERATOR_GROUP = 10310,

        HELPER_ID_TASK_TYPE_GROUP = 10326,
        HELPER_REMOTE = 10327,
        HELPER_DURATION_ESTIMATE = 10328,
        HELPER_ID_OPERATOR_CREATOR = 10329,
        HELPER_AUTHORIZED = 10330,
        HELPER_IMR_OPERATOR = 10331,
        HELPER_CODE = 10332,

        CONFIGURATION_PROFILE_ID_DESCR = 10354,

        DASHBOARD_DX_FILTER_ROW_VISIBLE = 10365,

        // Order
        HELPER_ID_ORDER_STATUS = 10367,

        HELPER_ID_SOURCE_OPERATOR = 10385,

        HELPER_DEVICE_HAS_VALVE = 10389,

        //Report
        REPORT_NAME = 12001,
        REPORT_DESCRIPTION = 12002,
        REPORT_START_DAYS_BACK = 12003,
        REPORT_END_DAYS_BACK = 12004,
        REPORT_START_MINUTES_BACK = 12005,
        REPORT_END_MINUTES_BACK = 12006,
        REPORT_SCHEDULE_FREQUENCY_VALUE = 12007,
        REPORT_SCHEDULE_FREQUENCY_UNIT = 12008,
        REPORT_SCHEDULE_TOLERANCE_BACK_VALUE = 12009,
        REPORT_SCHEDULE_TOLERANCE_BACK_UNIT = 12010,
        REPORT_SCHEDULE_TOLERANCE_FORW_VALUE = 12011,
        REPORT_SCHEDULE_TOLERANCE_FORW_UNIT = 12012,
        REPORT_SCHEDULE_MODE = 12013,
        REPORT_SCHEDULE_EMPTY_ROWS = 12014,
        REPORT_LOCATION_DATA = 12015,
        REPORT_METER_DATA = 12016,
        REPORT_DEVICE_DATA = 12017,
        REPORT_MEASURES_DATA = 12018,
        REPORT_PAGE_SIZE = 12019,
        REPORT_INCLUDE_METERS_IN_ROWS = 12020,
        REPORT_INCLUDE_DEVICES_IN_ROWS = 12021,
        REPORT_START_TIME = 12022,
        REPORT_END_TIME = 12023,
        REPORT_USE_SCHEDULE = 12024,
        REPORT_STORED_PROCEDURE = 12025,
        REPORT_SAVE_PATH_MANUALLY_CREATED = 12026,
        REPORT_SOURCE_SERVER_ID = 12027,//ID_REPORT
        REPORT_IMR_SERVER_ID = 12028,//ID_IMR_SERVER
        REPORT_FIRST_GENERATION_DATE = 12029,//Data pierwszego wygenerowania raportu
        REPORT_DATA_GENERATION_CHECK = 12030,
        REPORT_EMAIL_SENT_CHECK = 12031,
        REPORT_FTP_SENT_CHECK = 12032,
        REPORT_ID = 12033,
        REPORT_TYPE = 12034,
        REPORT_STATE = 12035,
        REPORT_OPERATOR_NAME = 12036,
        REPORT_STATE_TIME = 12037,
        REPORT_VALUE_BOOL = 12038,
        REPORT_VALUE_VAR = 12039,
        REPORT_VALUE_NOTE = 12040,
        REPORT_DEADLINE = 12041,
        REPORT_STATE_NOTE = 12042,
        REPORT_PRIORITY = 12043,
        REPORT_REASON = 12044,
        REPORT_GUID = 12045,
        REPORT_USE_CORE_DATABASE = 12046,
        REPORT_PDF_EXPORT_OPTIONS = 12047,
        REPORT_XLS_EXPORT_OPTIONS = 12048,
        REPORT_XLSX_EXPORT_OPTIONS = 12049,
        REPORT_CSV_EXPORT_OPTIONS = 12050,
        REPORT_TXT_EXPORT_OPTIONS = 12051,
        REPORT_ID_DISTRIBUTOR = 12052,
        REPORT_SSRS_ADDRESS = 12053,
        REPORT_VERSION = 12054,
        REPORT_PREVIOUS_VERSION = 12055,
        REPORT_GROUP_RESULT_BY_COLUMN = 12056,

        SSRS_USER_NAME = 12056,
        SSRS_USER_PASSWORD = 12057,
        SSRS_USER_DOMAIN = 12058,

        REPORT_SAVE_PATH = 12059,

        // #region DEVICE_TYPE params

        DEVICE_TYPE_IS_SET = 14025,

        // #endregion

        //IMR Service Centre params
        DEPOSITORY_ID = 17005,

        TASK_FITTER_VISIT_DATE = 17100,
        TASK_FITTER_PAYMENT_DONE = 17101,
        TASK_CLIENT_PAYMENT_DONE = 17102,
        TASK_PAYMENT_AMOUNT = 17105,
        TASK_PAYMENT_NOTE = 17106,
        TASK_FITTER_PAYMENT_DATE = 17107,
        TASK_ADDITIONAL_PAYMENT = 17114,

        PACKAGE_DIRECTION = 17020,
        PACKAGE_ADDRESS = 17021,

        DISTRIBUTOR_DEFAULT_CURRENCY_ID = 17524,

        TARIFF_IS_ACTIVE = 18516,
        TARIFF_ACTIVATION_TIME = 18517,
        TARIFF_CODE = 18545,
        HELPER_ID_TARIFF = 18602,

        //Profile
        PROFILE_LOCATION_CUSTOM_FORMAT_STRING = 22259,
        PROFILE_DEVICE_CUSTOM_FORMAT_STRING = 22260,
        PROFILE_METER_CUSTOM_FORMAT_STRING = 22261,
        PROFILE_TASK_CUSTOM_FORMAT_STRING = 22262,
        PROFILE_ISSUE_CUSTOM_FORMAT_STRING = 22263,
        PROFILE_ROUTE_CUSTOM_FORMAT_STRING = 22264,
        PROFILE_REPORT_CUSTOM_FORMAT_STRING = 22265,
        PROFILE_SIM_CARD_CUSTOM_FORMAT_STRING = 22266,
        PROFILE_OPERATOR_CUSTOM_FORMAT_STRING = 22267,
        PROFILE_DISTRIBUTOR_CUSTOM_FORMAT_STRING = 22268,

        PROFILE_LOCATION_MARKER_CUSTOM_FORMAT_STRING = 22269,

        PROFILE_MARKER_COLOR = 22270,
        PROFILE_MARKER_COLOR_CONDITION = 22271,
        PROFILE_MARKER_ID_REFERENCE_TYPE = 22272,

        PROFILE_ROW_COLOR = 22277,
        PROFILE_ROW_COLOR_CONDITION = 22278,
        PROFILE_ROW_ID_REFERENCE_TYPE = 22279,

        PROFILE_METER_MARKER_CUSTOM_FORMAT_STRING = 22356,
        PROFILE_DEVICE_MARKER_CUSTOM_FORMAT_STRING = 22357,

        PROFILE_CONFIGURATION_CODE = 22441,

        PROFILE_PAGE_ITEMS_NUMBER = 22447,

        PROFILE_MAP_PROVIDER = 22468,

        PROFILE_TASK_MARKER_CUSTOM_FORMAT_STRING = 22470,
        PROFILE_TASK_MARKER_CUSTOM_FORMAT_STRING_LOCALIZED = 22471,

        TASK_FITTER_ORDERED_TO_PAY = 22588,
        TASK_CLIENT_ORDERED_TO_PAY = 22589,
        TASK_CLIENT_PAYMENT_AMOUNT = 22590,
        TASK_CLIENT_PAYMENT_DATE = 22591,

        TASK_ID_TECHNICAL_PERMISSION = 22894,

        HELPER_COLOR = 28039,
        HELPER_ROW_COLOR = 28040,

        HELPER_ID_PACKAGE = 28509,
        HELPER_ID_PACKAGE_STATUS = 28513,

        ARTICLE_ID_DEVICE_TYPE = 30704,

        //View Column
        VIEW_COLUMN_SKIP_TRANSLATION = 34710,
        VIEW_COLUMN_IS_HIDDEN = 34716,

        PROFILE_LOCATION_EDIT_FORM = 40524,

        //Input Params gatherning place
        PROFILE_IMPORT_INPUT_PARAMS_MODE = 40536,

        //Map Provider Params
        PROFILE_MAP_PROVIDER_PARAM_OWNER = 40537,
        PROFILE_MAP_PROVIDER_PARAM_MAP_ID = 40538,
        PROFILE_MAP_PROVIDER_PARAM_URL = 40539,

        DEVICE_UDI_DESCRIPTION_1 = 105314,
        DEVICE_UDI_DESCRIPTION_2 = 105315,
        DEVICE_UDI_DESCRIPTION_3 = 105316,
        DEVICE_UDI_DESCRIPTION_4 = 105317,

        DEVICE_UDI_CONFIGURATION_1 = 105319,
        DEVICE_UDI_CONFIGURATION_2 = 105320,
        DEVICE_UDI_CONFIGURATION_3 = 105321,
        DEVICE_UDI_CONFIGURATION_4 = 105322,
        DEVICE_UDO_CONFIGURATION = 105323,
        DEVICE_UDO_DESCRIPTION = 105324,

        DEVICE_UDI_ENABLED_1 = 105384,
        DEVICE_UDI_ENABLED_2 = 105385,
        DEVICE_UDI_ENABLED_3 = 105386,
        DEVICE_UDI_ENABLED_4 = 105387,

        // Valve 
        VALDRIVER_STATE = 100166,

        DEVICE_UDI_DESCRIPTION_1_ID_DESCR = 105768,
        DEVICE_UDI_DESCRIPTION_2_ID_DESCR = 105769,
        DEVICE_UDI_DESCRIPTION_3_ID_DESCR = 105770,
        DEVICE_UDI_DESCRIPTION_4_ID_DESCR = 105771,

        SUPPLIER_LOGO = 90001,
        SUPPLIER_ORDER_GAS_EMAIL_TEMPLATE = 90003,
        SUPPLIER_ORDER_GAS_EMAIL_ID_LANGUAGE = 90005,

    }

    // #endregion

    // #region DataTypeClass

    /**
     * IMR.Suite.Common.Enums.DataTypeClass
     * */
    export enum DataTypeClass {
        Unknown = 0,
        Integer = 1,
        Real = 2,
        Text = 3,
        Date = 4,
        Time = 5,
        Datetime = 6,
        Boolean = 7,
        Object = 8,
        Xml = 9,
        Color = 10,
        Binary = 11,
        Decimal = 12,
    }

    // #endregion

    // #region DataTypeGroup

    /**
     * IMR.Suite.Common.Enums.DataTypeGroup
     * */
    export class DataTypeGroup {
        // ACTOR
        public static WEBSIMAX_ACTOR_DEFAULT_GRID_PARAMS = "WEBSIMAX_ACTOR_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_ACTOR_GRID_PARAMS = "WEBSIMAX_ACTOR_GRID_PARAMS";
        public static WEBSIMAX_ACTOR_GROUP_GRID_PARAMS = "WEBSIMAX_ACTOR_GROUP_GRID_PARAMS";
        public static WEBSIMAX_ACTOR_IMPORT_PARAMS = "WEBSIMAX_ACTOR_IMPORT_PARAMS";
        public static WEBSIMAX_ACTOR_LOCATION_GRID_PARAMS = "WEBSIMAX_ACTOR_LOCATION_GRID_PARAMS";
        public static WEBSIMAX_ACTOR_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_ACTOR_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_ACTOR_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_ACTOR_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_ACTOR_PARAMS_REQUIRED = "WEBSIMAX_ACTOR_PARAMS_REQUIRED";
        public static WEBSIMAX_ACTOR_POPUP_GRID_PARAMS = "WEBSIMAX_ACTOR_POPUP_GRID_PARAMS";
        public static WEBSIMAX_ACTOR_PREVIEW_PANEL_PARAMS = "WEBSIMAX_ACTOR_PREVIEW_PANEL_PARAMS";

        // DEPOSITORY
        public static WEBSIMAX_DEPOSITORY_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_DEPOSITORY_PANEL_PARAMS_TO_DISPLAY"
        public static WEBSIMAX_DEPOSITORY_GRID_PARAMS = "WEBSIMAX_DEPOSITORY_GRID_PARAMS";
        public static WEBSIMAX_DEPOSITORY_DEFAULT_GRID_PARAMS = "WEBSIMAX_DEPOSITORY_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_DEPOSITORY_CONTENT_GRID_PARAMS = "WEBSIMAX_DEPOSITORY_CONTENT_GRID_PARAMS";

        // GROUPING LOCATION
        public static WEBSIMAX_GROUPING_LOCATION = "WEBSIMAX_GROUPING_LOCATION";
        public static WEBSIMAX_GROUPING_LOCATION_GRID_PARAMS = "WEBSIMAX_GROUPING_LOCATION_GRID_PARAMS";
        public static WEBSIMAX_GROUPING_LOCATION_DEFAULT_GRID_PARAMS = "WEBSIMAX_GROUPING_LOCATION_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_GROUPING_LOCATION_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_GROUPING_LOCATION_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_GROUPING_LOCATION_ASSIGNED_LOCATION_GRID_PARAMS = "WEBSIMAX_GROUPING_LOCATION_ASSIGNED_LOCATION_GRID_PARAMS";
        public static WEBSIMAX_GROUPING_LOCATION_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_GROUPING_LOCATION_PANEL_PARAMS_TO_EDIT";

        // REPORT
        public static WEBSIMAX_REPORT_GRID_PARAMS = "WEBSIMAX_REPORT_GRID_PARAMS";
        public static WEBSIMAX_REPORT_DEFAULT_GRID_PARAMS = "WEBSIMAX_REPORT_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_REPORT_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_REPORT_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_REPORT_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_REPORT_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_REPORT_PARAMS_REQUIRED = "WEBSIMAX_REPORT_PARAMS_REQUIRED";
        public static WEBSIMAX_REPORT_PREVIEW_PANEL_PARAMS = "WEBSIMAX_REPORT_PREVIEW_PANEL_PARAMS";
        public static WEBSIMAX_REPORT_POPUP_GRID_PARAMS = "WEBSIMAX_REPORT_POPUP_GRID_PARAMS";


        public static WEBSIMAX_LOCATION_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_LOCATION_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_LOCATION_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_LOCATION_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_METER_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_METER_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_METER_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_METER_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_DEVICE_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_DEVICE_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_DEVICE_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_DEVICE_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_LOCATION_DEFAULT_GRID_PARAMS = "WEBSIMAX_LOCATION_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_LOCATION_GRID_PARAMS = "WEBSIMAX_LOCATION_GRID_PARAMS";
        public static WEBSIMAX_DEVICE_DEFAULT_GRID_PARAMS = "WEBSIMAX_DEVICE_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_DEVICE_GRID_PARAMS = "WEBSIMAX_DEVICE_GRID_PARAMS";
        public static WEBSIMAX_METER_DEFAULT_GRID_PARAMS = "WEBSIMAX_METER_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_METER_GRID_PARAMS = "WEBSIMAX_METER_GRID_PARAMS";
        public static WEBSIMAX_LOCATION_MEASUREMENTS = "WEBSIMAX_LOCATION_MEASUREMENTS";
        public static WEBSIMAX_DEVICE_MEASUREMENTS = "WEBSIMAX_DEVICE_MEASUREMENTS";
        public static WEBSIMAX_METER_MEASUREMENTS = "WEBSIMAX_METER_MEASUREMENTS";
        public static WEBSIMAX_OPERATOR_DEFAULT_GRID_PARAMS = "WEBSIMAX_OPERATOR_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_OPERATOR_GRID_PARAMS = "WEBSIMAX_OPERATOR_GRID_PARAMS";
        public static WEBSIMAX_OPERATOR_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_OPERATOR_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_OPERATOR_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_OPERATOR_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_TASK_DEFAULT_GRID_PARAMS = "WEBSIMAX_TASK_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_TASK_GRID_PARAMS = "WEBSIMAX_TASK_GRID_PARAMS";
        public static WEBSIMAX_TASK_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_TASK_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_TASK_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_TASK_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_ISSUE_DEFAULT_GRID_PARAMS = "WEBSIMAX_ISSUE_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_ISSUE_GRID_PARAMS = "WEBSIMAX_ISSUE_GRID_PARAMS";
        public static WEBSIMAX_ISSUE_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_ISSUE_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_ISSUE_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_ISSUE_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_DEVICE_PARAMS_REQUIRED = "WEBSIMAX_DEVICE_PARAMS_REQUIRED";
        public static WEBSIMAX_ISSUE_PARAMS_REQUIRED = "WEBSIMAX_ISSUE_PARAMS_REQUIRED";
        public static WEBSIMAX_LOCATION_PARAMS_REQUIRED = "WEBSIMAX_LOCATION_PARAMS_REQUIRED";
        public static WEBSIMAX_METER_PARAMS_REQUIRED = "WEBSIMAX_METER_PARAMS_REQUIRED";
        public static WEBSIMAX_OPERATOR_PARAMS_REQUIRED = "WEBSIMAX_OPERATOR_PARAMS_REQUIRED";
        public static WEBSIMAX_TASK_PARAMS_REQUIRED = "WEBSIMAX_TASK_PARAMS_REQUIRED";
        public static WEBSIMAX_DEVICE_GRID_PARAMS_TO_DISPLAY = "WEBSIMAX_DEVICE_GRID_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_DEVICE_GRID_PARAMS_TO_EDIT = "WEBSIMAX_DEVICE_GRID_PARAMS_TO_EDIT";
        public static WEBSIMAX_DISTRIBUTOR_DEFAULT_GRID_PARAMS = "WEBSIMAX_DISTRIBUTOR_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_DISTRIBUTOR_GRID_PARAMS = "WEBSIMAX_DISTRIBUTOR_GRID_PARAMS";
        public static WEBSIMAX_DISTRIBUTOR_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_DISTRIBUTOR_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_DISTRIBUTOR_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_DISTRIBUTOR_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_DISTRIBUTOR_PARAMS_REQUIRED = "WEBSIMAX_DISTRIBUTOR_PARAMS_REQUIRED";
        public static WEBSIMAX_ALARM_DEFAULT_GRID_PARAMS = "WEBSIMAX_ALARM_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_ALARM_GRID_PARAMS = "WEBSIMAX_ALARM_GRID_PARAMS";
        public static WEBSIMAX_ALARM_PARAMS_REQUIRED = "WEBSIMAX_ALARM_PARAMS_REQUIRED";
        public static WEBSIMAX_ALARM_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_ALARM_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_ALARM_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_ALARM_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_LOCATION_DEVICE_GRID_PARAMS = "WEBSIMAX_LOCATION_DEVICE_GRID_PARAMS";
        public static WEBSIMAX_LOCATION_METER_GRID_PARAMS = "WEBSIMAX_LOCATION_METER_GRID_PARAMS";
        public static WEBSIMAX_ISSUE_TASK_GRID_PARAMS = "WEBSIMAX_ISSUE_TASK_GRID_PARAMS";
        public static WEBSIMAX_ROUTE_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_ROUTE_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_ROUTE_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_ROUTE_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_ROUTE_PARAMS_REQUIRED = "WEBSIMAX_ROUTE_PARAMS_REQUIRED";
        public static WEBSIMAX_ROUTE_GRID_PARAMS = "WEBSIMAX_ROUTE_GRID_PARAMS";
        public static WEBSIMAX_ROUTE_DEFAULT_GRID_PARAMS = "WEBSIMAX_ROUTE_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_DATA_TYPE_CHART_TYPE = "WEBSIMAX_DATA_TYPE_CHART_TYPE";
        public static WEBSIMAX_METER_DEVICE_GRID_PARAMS = "WEBSIMAX_METER_DEVICE_GRID_PARAMS";
        public static WEBSIMAX_SIM_CARD_GRID_PARAMS = "WEBSIMAX_SIM_CARD_GRID_PARAMS";
        public static WEBSIMAX_SIM_CARD_DEFAULT_GRID_PARAMS = "WEBSIMAX_SIM_CARD_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_SIM_CARD_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_SIM_CARD_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_SIM_CARD_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_SIM_CARD_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_SIM_CARD_PARAMS_REQUIRED = "WEBSIMAX_SIM_CARD_PARAMS_REQUIRED";
        public static WEBSIMAX_ACTION_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_ACTION_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_ACTION_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_ACTION_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_ACTION_PARAMS_REQUIRED = "WEBSIMAX_ACTION_PARAMS_REQUIRED";
        public static WEBSIMAX_LOCATION_PREVIEW_PANEL_PARAMS = "WEBSIMAX_LOCATION_PREVIEW_PANEL_PARAMS";
        public static WEBSIMAX_METER_PREVIEW_PANEL_PARAMS = "WEBSIMAX_METER_PREVIEW_PANEL_PARAMS";
        public static WEBSIMAX_DEVICE_PREVIEW_PANEL_PARAMS = "WEBSIMAX_DEVICE_PREVIEW_PANEL_PARAMS";
        public static WEBSIMAX_OPERATOR_PREVIEW_PANEL_PARAMS = "WEBSIMAX_OPERATOR_PREVIEW_PANEL_PARAMS";
        public static WEBSIMAX_TASK_PREVIEW_PANEL_PARAMS = "WEBSIMAX_TASK_PREVIEW_PANEL_PARAMS";
        public static WEBSIMAX_ISSUE_PREVIEW_PANEL_PARAMS = "WEBSIMAX_ISSUE_PREVIEW_PANEL_PARAMS";
        public static WEBSIMAX_DISTRIBUTOR_PREVIEW_PANEL_PARAMS = "WEBSIMAX_DISTRIBUTOR_PREVIEW_PANEL_PARAMS";
        public static WEBSIMAX_ALARM_PREVIEW_PANEL_PARAMS = "WEBSIMAX_ALARM_PREVIEW_PANEL_PARAMS";
        public static WEBSIMAX_SIM_CARD_PREVIEW_PANEL_PARAMS = "WEBSIMAX_SIM_CARD_PREVIEW_PANEL_PARAMS";
        public static WEBSIMAX_ACTION_PREVIEW_PANEL_PARAMS = "WEBSIMAX_ACTION_PREVIEW_PANEL_PARAMS";
        public static WEBSIMAX_ROUTE_TASK_GRID_PARAMS = "WEBSIMAX_ROUTE_TASK_GRID_PARAMS";
        public static WEBSIMAX_ROUTE_OPERATOR_GRID_PARAMS = "WEBSIMAX_ROUTE_OPERATOR_GRID_PARAMS";
        public static WEBSIMAX_ACTION_GRID_PARAMS = "WEBSIMAX_ACTION_GRID_PARAMS";
        public static WEBSIMAX_ACTION_DEFAULT_GRID_PARAMS = "WEBSIMAX_ACTION_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_LOCATION_GRID_PARAMS_TO_DISPLAY = "WEBSIMAX_LOCATION_GRID_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_LOCATION_GRID_PARAMS_TO_EDIT = "WEBSIMAX_LOCATION_GRID_PARAMS_TO_EDIT";
        public static WEBSIMAX_ROUTE_LOCATION_GRID_PARAMS = "WEBSIMAX_ROUTE_LOCATION_GRID_PARAMS";
        public static WEBSIMAX_DEVICE_CONNECTION_GRID_PARAMS = "WEBSIMAX_DEVICE_CONNECTION_GRID_PARAMS";
        public static WEBSIMAX_DEVICE_CONNECTION_DEFAULT_GRID_PARAMS = "WEBSIMAX_DEVICE_CONNECTION_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_DEVICE_CONNECTION_PREVIEW_PANEL_PARAMS = "WEBSIMAX_DEVICE_CONNECTION_PREVIEW_PANEL_PARAMS";
        public static WEBSIMAX_METER_ALARM_DEF_PARAMS = "WEBSIMAX_METER_ALARM_DEF_PARAMS";
        public static WEBSIMAX_METER_ALARM_DEF_REF_PARAMS = "WEBSIMAX_METER_ALARM_DEF_REF_PARAMS";
        public static WEBSIMAX_ALARM_GROUP_DEFAULT_GRID_PARAMS = "WEBSIMAX_ALARM_GROUP_DEFAULT_GRID_PARAMS";
        public static WEBSIMAX_ALARM_GROUP_GRID_PARAMS = "WEBSIMAX_ALARM_GROUP_GRID_PARAMS";
        public static WEBSIMAX_ALARM_GROUP_PANEL_PARAMS_TO_DISPLAY = "WEBSIMAX_ALARM_GROUP_PANEL_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_ALARM_GROUP_PANEL_PARAMS_TO_EDIT = "WEBSIMAX_ALARM_GROUP_PANEL_PARAMS_TO_EDIT";
        public static WEBSIMAX_ALARM_GROUP_PARAMS_REQUIRED = "WEBSIMAX_ALARM_GROUP_PARAMS_REQUIRED";
        public static WEBSIMAX_ROUTE_IMPORT_PARAMS = "WEBSIMAX_ROUTE_IMPORT_PARAMS";
        public static WEBSIMAX_ISSUE_IMPORT_PARAMS = "WEBSIMAX_ISSUE_IMPORT_PARAMS";
        public static WEBSIMAX_TASK_IMPORT_PARAMS = "WEBSIMAX_TASK_IMPORT_PARAMS";
        public static WEBSIMAX_LOCATION_IMPORT_PARAMS = "WEBSIMAX_LOCATION_IMPORT_PARAMS";
        public static WEBSIMAX_DEVICE_IMPORT_PARAMS = "WEBSIMAX_DEVICE_IMPORT_PARAMS";
        public static WEBSIMAX_METER_IMPORT_PARAMS = "WEBSIMAX_METER_IMPORT_PARAMS";
        public static WEBSIMAX_SIM_CARD_IMPORT_PARAMS = "WEBSIMAX_SIM_CARD_IMPORT_PARAMS";
        public static WEBSIMAX_OPERATOR_IMPORT_PARAMS = "WEBSIMAX_OPERATOR_IMPORT_PARAMS";
        public static IMREVA_ACTION_PANEL_PARAMS_TO_EDIT = "IMREVA_ACTION_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_ACTION_PANEL_PARAMS_TO_DISPLAY = "IMREVA_ACTION_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_ACTION_PARAMS_REQUIRED = "IMREVA_ACTION_PARAMS_REQUIRED";
        public static IMREVA_ACTION_GRID_PARAMS = "IMREVA_ACTION_GRID_PARAMS";
        public static IMREVA_ACTION_DEFAULT_GRID_PARAMS = "IMREVA_ACTION_DEFAULT_GRID_PARAMS";
        public static IMREVA_ACTION_PREVIEW_PANEL_PARAMS = "IMREVA_ACTION_PREVIEW_PANEL_PARAMS";
        public static IMREVA_ACTOR_DEFAULT_GRID_PARAMS = "IMREVA_ACTOR_DEFAULT_GRID_PARAMS";
        public static IMREVA_ACTOR_GRID_PARAMS = "IMREVA_ACTOR_GRID_PARAMS";
        public static IMREVA_ACTOR_PANEL_PARAMS_TO_DISPLAY = "IMREVA_ACTOR_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_ACTOR_PANEL_PARAMS_TO_EDIT = "IMREVA_ACTOR_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_ACTOR_PARAMS_REQUIRED = "IMREVA_ACTOR_PARAMS_REQUIRED";
        public static IMREVA_ACTOR_IMPORT_PARAMS = "IMREVA_ACTOR_IMPORT_PARAMS";
        public static IMREVA_ACTOR_LOCATION_GRID_PARAMS = "IMREVA_ACTOR_LOCATION_GRID_PARAMS";
        public static IMREVA_ACTOR_PREVIEW_PANEL_PARAMS = "IMREVA_ACTOR_PREVIEW_PANEL_PARAMS";
        public static IMREVA_ALARM_DEFAULT_GRID_PARAMS = "IMREVA_ALARM_DEFAULT_GRID_PARAMS";
        public static IMREVA_ALARM_GRID_PARAMS = "IMREVA_ALARM_GRID_PARAMS";
        public static IMREVA_ALARM_PARAMS_REQUIRED = "IMREVA_ALARM_PARAMS_REQUIRED";
        public static IMREVA_ALARM_PANEL_PARAMS_TO_DISPLAY = "IMREVA_ALARM_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_ALARM_PANEL_PARAMS_TO_EDIT = "IMREVA_ALARM_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_ALARM_PREVIEW_PANEL_PARAMS = "IMREVA_ALARM_PREVIEW_PANEL_PARAMS";
        public static IMREVA_ALARM_GROUP_DEFAULT_GRID_PARAMS = "IMREVA_ALARM_GROUP_DEFAULT_GRID_PARAMS";
        public static IMREVA_ALARM_GROUP_GRID_PARAMS = "IMREVA_ALARM_GROUP_GRID_PARAMS";
        public static IMREVA_ALARM_GROUP_PANEL_PARAMS_TO_DISPLAY = "IMREVA_ALARM_GROUP_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_ALARM_GROUP_PANEL_PARAMS_TO_EDIT = "IMREVA_ALARM_GROUP_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_ALARM_GROUP_PARAMS_REQUIRED = "IMREVA_ALARM_GROUP_PARAMS_REQUIRED";
        public static IMREVA_DATA_TYPE_CHART_TYPE = "IMREVA_DATA_TYPE_CHART_TYPE";
        public static IMREVA_DISTRIBUTOR_DEFAULT_GRID_PARAMS = "IMREVA_DISTRIBUTOR_DEFAULT_GRID_PARAMS";
        public static IMREVA_DISTRIBUTOR_GRID_PARAMS = "IMREVA_DISTRIBUTOR_GRID_PARAMS";
        public static IMREVA_DISTRIBUTOR_PANEL_PARAMS_TO_DISPLAY = "IMREVA_DISTRIBUTOR_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_DISTRIBUTOR_PANEL_PARAMS_TO_EDIT = "IMREVA_DISTRIBUTOR_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_DISTRIBUTOR_PARAMS_REQUIRED = "IMREVA_DISTRIBUTOR_PARAMS_REQUIRED";
        public static IMREVA_DISTRIBUTOR_PREVIEW_PANEL_PARAMS = "IMREVA_DISTRIBUTOR_PREVIEW_PANEL_PARAMS";
        public static IMREVA_DEVICE_PANEL_PARAMS_TO_DISPLAY = "IMREVA_DEVICE_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_DEVICE_PANEL_PARAMS_TO_EDIT = "IMREVA_DEVICE_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_DEVICE_DEFAULT_GRID_PARAMS = "IMREVA_DEVICE_DEFAULT_GRID_PARAMS";
        public static IMREVA_DEVICE_GRID_PARAMS = "IMREVA_DEVICE_GRID_PARAMS";
        public static IMREVA_DEVICE_MEASUREMENTS = "IMREVA_DEVICE_MEASUREMENTS";
        public static IMREVA_DEVICE_PARAMS_REQUIRED = "IMREVA_DEVICE_PARAMS_REQUIRED";
        public static IMREVA_DEVICE_GRID_PARAMS_TO_DISPLAY = "IMREVA_DEVICE_GRID_PARAMS_TO_DISPLAY";
        public static IMREVA_DEVICE_GRID_PARAMS_TO_EDIT = "IMREVA_DEVICE_GRID_PARAMS_TO_EDIT";
        public static IMREVA_DEVICE_PREVIEW_PANEL_PARAMS = "IMREVA_DEVICE_PREVIEW_PANEL_PARAMS";
        public static IMREVA_DEVICE_IMPORT_PARAMS = "IMREVA_DEVICE_IMPORT_PARAMS";
        public static IMREVA_DEVICE_CONNECTION_GRID_PARAMS = "IMREVA_DEVICE_CONNECTION_GRID_PARAMS";
        public static IMREVA_DEVICE_CONNECTION_DEFAULT_GRID_PARAMS = "IMREVA_DEVICE_CONNECTION_DEFAULT_GRID_PARAMS";
        public static IMREVA_DEVICE_CONNECTION_PREVIEW_PANEL_PARAMS = "IMREVA_DEVICE_CONNECTION_PREVIEW_PANEL_PARAMS";
        public static IMREVA_ISSUE_DEFAULT_GRID_PARAMS = "IMREVA_ISSUE_DEFAULT_GRID_PARAMS";
        public static IMREVA_ISSUE_GRID_PARAMS = "IMREVA_ISSUE_GRID_PARAMS";
        public static IMREVA_ISSUE_PANEL_PARAMS_TO_DISPLAY = "IMREVA_ISSUE_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_ISSUE_PANEL_PARAMS_TO_EDIT = "IMREVA_ISSUE_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_ISSUE_PARAMS_REQUIRED = "IMREVA_ISSUE_PARAMS_REQUIRED";
        public static IMREVA_ISSUE_TASK_GRID_PARAMS = "IMREVA_ISSUE_TASK_GRID_PARAMS";
        public static IMREVA_ISSUE_PREVIEW_PANEL_PARAMS = "IMREVA_ISSUE_PREVIEW_PANEL_PARAMS";
        public static IMREVA_ISSUE_IMPORT_PARAMS = "IMREVA_ISSUE_IMPORT_PARAMS";
        public static IMREVA_LOCATION_PANEL_PARAMS_TO_DISPLAY = "IMREVA_LOCATION_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_LOCATION_PANEL_PARAMS_TO_EDIT = "IMREVA_LOCATION_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_LOCATION_DEFAULT_GRID_PARAMS = "IMREVA_LOCATION_DEFAULT_GRID_PARAMS";
        public static IMREVA_LOCATION_GRID_PARAMS = "IMREVA_LOCATION_GRID_PARAMS";
        public static IMREVA_LOCATION_MEASUREMENTS = "IMREVA_LOCATION_MEASUREMENTS";
        public static IMREVA_LOCATION_PARAMS_REQUIRED = "IMREVA_LOCATION_PARAMS_REQUIRED";
        public static IMREVA_LOCATION_DEVICE_GRID_PARAMS = "IMREVA_LOCATION_DEVICE_GRID_PARAMS";
        public static IMREVA_LOCATION_METER_GRID_PARAMS = "IMREVA_LOCATION_METER_GRID_PARAMS";
        public static IMREVA_LOCATION_PREVIEW_PANEL_PARAMS = "IMREVA_LOCATION_PREVIEW_PANEL_PARAMS";
        public static IMREVA_LOCATION_IMPORT_PARAMS = "IMREVA_LOCATION_IMPORT_PARAMS";
        public static IMREVA_LOCATION_GRID_PARAMS_TO_DISPLAY = "IMREVA_LOCATION_GRID_PARAMS_TO_DISPLAY";
        public static IMREVA_LOCATION_GRID_PARAMS_TO_EDIT = "IMREVA_LOCATION_GRID_PARAMS_TO_EDIT";
        public static IMREVA_METER_PANEL_PARAMS_TO_DISPLAY = "IMREVA_METER_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_METER_PANEL_PARAMS_TO_EDIT = "IMREVA_METER_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_METER_DEFAULT_GRID_PARAMS = "IMREVA_METER_DEFAULT_GRID_PARAMS";
        public static IMREVA_METER_GRID_PARAMS = "IMREVA_METER_GRID_PARAMS";
        public static IMREVA_METER_MEASUREMENTS = "IMREVA_METER_MEASUREMENTS";
        public static IMREVA_METER_PARAMS_REQUIRED = "IMREVA_METER_PARAMS_REQUIRED";
        public static IMREVA_METER_DEVICE_GRID_PARAMS = "IMREVA_METER_DEVICE_GRID_PARAMS";
        public static IMREVA_METER_PREVIEW_PANEL_PARAMS = "IMREVA_METER_PREVIEW_PANEL_PARAMS";
        public static IMREVA_METER_IMPORT_PARAMS = "IMREVA_METER_IMPORT_PARAMS";
        public static IMREVA_METER_ALARM_DEF_PARAMS = "IMREVA_METER_ALARM_DEF_PARAMS";
        public static IMREVA_METER_ALARM_DEF_REF_PARAMS = "IMREVA_METER_ALARM_DEF_REF_PARAMS";
        public static IMREVA_OPERATOR_DEFAULT_GRID_PARAMS = "IMREVA_OPERATOR_DEFAULT_GRID_PARAMS";
        public static IMREVA_OPERATOR_GRID_PARAMS = "IMREVA_OPERATOR_GRID_PARAMS";
        public static IMREVA_OPERATOR_PANEL_PARAMS_TO_DISPLAY = "IMREVA_OPERATOR_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_OPERATOR_PANEL_PARAMS_TO_EDIT = "IMREVA_OPERATOR_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_OPERATOR_PARAMS_REQUIRED = "IMREVA_OPERATOR_PARAMS_REQUIRED";
        public static IMREVA_OPERATOR_IMPORT_PARAMS = "IMREVA_OPERATOR_IMPORT_PARAMS";
        public static IMREVA_OPERATOR_PREVIEW_PANEL_PARAMS = "IMREVA_OPERATOR_PREVIEW_PANEL_PARAMS";
        public static IMREVA_REPORT_GRID_PARAMS = "IMREVA_REPORT_GRID_PARAMS";
        public static IMREVA_REPORT_DEFAULT_GRID_PARAMS = "IMREVA_REPORT_DEFAULT_GRID_PARAMS";
        public static IMREVA_REPORT_PANEL_PARAMS_TO_EDIT = "IMREVA_REPORT_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_REPORT_PANEL_PARAMS_TO_DISPLAY = "IMREVA_REPORT_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_REPORT_PARAMS_REQUIRED = "IMREVA_REPORT_PARAMS_REQUIRED";
        public static IMREVA_REPORT_PREVIEW_PANEL_PARAMS = "IMREVA_REPORT_PREVIEW_PANEL_PARAMS";
        public static IMREVA_ROUTE_PANEL_PARAMS_TO_DISPLAY = "IMREVA_ROUTE_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_ROUTE_PANEL_PARAMS_TO_EDIT = "IMREVA_ROUTE_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_ROUTE_PARAMS_REQUIRED = "IMREVA_ROUTE_PARAMS_REQUIRED";
        public static IMREVA_ROUTE_GRID_PARAMS = "IMREVA_ROUTE_GRID_PARAMS";
        public static IMREVA_ROUTE_DEFAULT_GRID_PARAMS = "IMREVA_ROUTE_DEFAULT_GRID_PARAMS";
        public static IMREVA_ROUTE_LOCATION_GRID_PARAMS = "IMREVA_ROUTE_LOCATION_GRID_PARAMS";
        public static IMREVA_ROUTE_OPERATOR_GRID_PARAMS = "IMREVA_ROUTE_OPERATOR_GRID_PARAMS";
        public static IMREVA_ROUTE_TASK_GRID_PARAMS = "IMREVA_ROUTE_TASK_GRID_PARAMS";
        public static IMREVA_ROUTE_IMPORT_PARAMS = "IMREVA_ROUTE_IMPORT_PARAMS";
        public static IMREVA_SIM_CARD_GRID_PARAMS = "IMREVA_SIM_CARD_GRID_PARAMS";
        public static IMREVA_SIM_CARD_DEFAULT_GRID_PARAMS = "IMREVA_SIM_CARD_DEFAULT_GRID_PARAMS";
        public static IMREVA_SIM_CARD_PANEL_PARAMS_TO_EDIT = "IMREVA_SIM_CARD_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_SIM_CARD_PANEL_PARAMS_TO_DISPLAY = "IMREVA_SIM_CARD_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_SIM_CARD_PARAMS_REQUIRED = "IMREVA_SIM_CARD_PARAMS_REQUIRED";
        public static IMREVA_SIM_CARD_PREVIEW_PANEL_PARAMS = "IMREVA_SIM_CARD_PREVIEW_PANEL_PARAMS";
        public static IMREVA_SIM_CARD_IMPORT_PARAMS = "IMREVA_SIM_CARD_IMPORT_PARAMS";
        public static IMREVA_TASK_DEFAULT_GRID_PARAMS = "IMREVA_TASK_DEFAULT_GRID_PARAMS";
        public static IMREVA_TASK_GRID_PARAMS = "IMREVA_TASK_GRID_PARAMS";
        public static IMREVA_TASK_PANEL_PARAMS_TO_DISPLAY = "IMREVA_TASK_PANEL_PARAMS_TO_DISPLAY";
        public static IMREVA_TASK_PANEL_PARAMS_TO_EDIT = "IMREVA_TASK_PANEL_PARAMS_TO_EDIT";
        public static IMREVA_TASK_PARAMS_REQUIRED = "IMREVA_TASK_PARAMS_REQUIRED";
        public static IMREVA_TASK_PREVIEW_PANEL_PARAMS = "IMREVA_TASK_PREVIEW_PANEL_PARAMS";
        public static IMREVA_TASK_IMPORT_PARAMS = "IMREVA_TASK_IMPORT_PARAMS";
        public static WEBSIMAX_MEASUREMENT_THRESHOLD = "WEBSIMAX_MEASUREMENT_THRESHOLD";
        public static IMREVA_MEASUREMENT_THRESHOLD = "IMREVA_MEASUREMENT_THRESHOLD";
        public static WEBSIMAX_DATA_TYPE_SERIES_SEPARATE_Y_AXIS = "WEBSIMAX_DATA_TYPE_SERIES_SEPARATE_Y_AXIS";
        public static WEBSIMAX_METER_GRID_PARAMS_TO_DISPLAY = "WEBSIMAX_METER_GRID_PARAMS_TO_DISPLAY";
        public static WEBSIMAX_METER_GRID_PARAMS_TO_EDIT = "WEBSIMAX_METER_GRID_PARAMS_TO_EDIT";
        public static WEBSIMAX_LOCATION_POPUP_GRID_PARAMS = "WEBSIMAX_LOCATION_POPUP_GRID_PARAMS";
        public static WEBSIMAX_METER_POPUP_GRID_PARAMS = "WEBSIMAX_METER_POPUP_GRID_PARAMS";
        public static WEBSIMAX_DEVICE_POPUP_GRID_PARAMS = "WEBSIMAX_DEVICE_POPUP_GRID_PARAMS";
        public static WEBSIMAX_TASK_POPUP_GRID_PARAMS = "WEBSIMAX_TASK_POPUP_GRID_PARAMS";
        public static WEBSIMAX_ISSUE_POPUP_GRID_PARAMS = "WEBSIMAX_ISSUE_POPUP_GRID_PARAMS";
        public static WEBSIMAX_OPERATOR_POPUP_GRID_PARAMS = "WEBSIMAX_OPERATOR_POPUP_GRID_PARAMS";
        public static WEBSIMAX_DISTRIBUTOR_POPUP_GRID_PARAMS = "WEBSIMAX_DISTRIBUTOR_POPUP_GRID_PARAMS";
        public static WEBSIMAX_ALARM_EVENT_POPUP_GRID_PARAMS = "WEBSIMAX_ALARM_EVENT_POPUP_GRID_PARAMS";
        public static WEBSIMAX_ACTION_POPUP_GRID_PARAMS = "WEBSIMAX_ACTION_POPUP_GRID_PARAMS";
        public static WEBSIMAX_ROUTE_POPUP_GRID_PARAMS = "WEBSIMAX_ROUTE_POPUP_GRID_PARAMS";
        public static WEBSIMAX_SIM_CARD_POPUP_GRID_PARAMS = "WEBSIMAX_SIM_CARD_POPUP_GRID_PARAMS";
        public static WEBSIMAX_DATA_TYPE_MULTI_INDEX = "WEBSIMAX_DATA_TYPE_MULTI_INDEX";
        public static IMREVA_DEPOSITORY_CONTENT_GRID_PARAMS = "IMREVA_DEPOSITORY_CONTENT_GRID_PARAMS";
        public static WEBSIMAX_TASK_INSTALLED_DEVICES_GRID_PARAMS = "WEBSIMAX_TASK_INSTALLED_DEVICES_GRID_PARAMS";
        public static WEBSIMAX_TASK_UNINSTALLED_DEVICES_GRID_PARAMS = "WEBSIMAX_TASK_UNINSTALLED_DEVICES_GRID_PARAMS";
        public static WEBSIMAX_METER_ALARM_DEF_PANEL_PARAMS = "WEBSIMAX_METER_ALARM_DEF_PANEL_PARAMS";
        public static WEBSIMAX_DATA_TYPE_SERIES_COLOR = "WEBSIMAX_DATA_TYPE_SERIES_COLOR";
        public static WEBSIMAX_DATA_TYPE_HIDDEN_Y_AXIS: string = 'WEBSIMAX_DATA_TYPE_HIDDEN_Y_AXIS';
        public static WEBSIMAX_LOCATION_CUSTOM_CORE_PARAMS: string = 'WEBSIMAX_LOCATION_CUSTOM_CORE_PARAMS';
        public static WEBSIMAX_LOCATION_CUSTOM_DW_PARAMS: string = 'WEBSIMAX_LOCATION_CUSTOM_DW_PARAMS';
        public static WEBSIMAX_IMPORT_PLUGIN_PARAMS: string = 'WEBSIMAX_IMPORT_PLUGIN_PARAMS';
        public static WEBSIMAX_EXPORT_PLUGIN_PARAMS: string = 'WEBSIMAX_EXPORT_PLUGIN_PARAMS';
    }

    // #endregion

    // #region DashboardCardOptions

    /**
     * IMR.Suite.Common.Enums.DashboardCardOptions
     * */
    export enum DashboardCardOptions {
        Unknown = 0,
        Keeper = 1,
        Configuration = 2
    }

    // #endregion

    // #region DashboardItemClass

    /**
     * IMR.Suite.Common.Enums.DashboardItemClass
     * */
    export enum DashboardItemClass {
        TILE = 0,
        GAUGE = 1,
        CHART = 2,
        GRID = 3,
        CARD = 4,
        MAP = 5,
        SCHEMA = 6
    }

    // #endregion

    // #region DashboardType

    /**
     * IMR.Suite.Common.Enums.DashboardType
     * */
    export enum DashboardType {
        Standard = 0,
        DXDashboard = 1,
        DXDashboardMulti = 2
    }

    // #endregion

    // #region DeviceType

    export enum DeviceType {
        Unknown = 0,

        OLAN_5310_C713 = 85,

        OLANi5x5_xxD0 = 236,

    }
    // #endregion 

    // #region DeviceTypeClass

    export enum DeviceTypeClass {
        OKO = 1,
        RADIO_DEVICE = 2,
        ATG = 3,
        OTHER = 4,
        AMPLI = 5
    }

    // #endregion

    // #region DBCollectorProperties

    /**
     * IMR.Suite.Services.WCF.ImrWcfLib.DBCollector
     * */
    export enum DBCollectorProperties {
        Unknown = 0,
        ScMxInteface = 1,
        FTPEnable = 2,
        DiagnosticInvoke = 3,
        UserSessionReleaseTime = 4,
        InitWebSimaxDataProvider = 5,
        DataProviderLanguage = 6,
        Module = 7,
        CultureInfo = 8,
        InitDataProviderDefaultDataTypes = 9,
        CacheItemState = 10,
        DataChangeCheck = 11,
        EnableCallback = 12,
        OperationContext = 13,
        Relogin = 14,
        InitEmailConfiguration = 15,
        InitViewDefinitions = 16,
        GetIMRServerReleaseVersion = 17,
        IsIMRSCDatabase = 18,
        DistributorServerDict = 19,
        ServerDistributorDict = 20,
        ServerReportDict = 21,
        ServerSourceReportDict = 22,
        LocationDistributorDict = 23,
        LocationSourceDistributorDict = 24,
        MeterDistributorDict = 25,
        MeterSourceDistributorDict = 26,
        DeviceDistributorDict = 27,
        OperatorDistributorDict = 28,
        OperatorSourceDistributorDict = 29,
        OperatorSerialNbrDistributorDict = 30,
        OperatorSerialNbrSourceDistributorDict = 31,
        ServerClientDict = 32,
        ServerLoggedOperatorDict = 33,
        ServerAddressDict = 34,
        ServerDict = 35,
        ActionTypeServerDict = 36,
        ActionTypeSourceServerDict = 37,
        DeviceOrderNumberServerDict = 38,
        DeviceOrderNumberSourceServerDict = 39,
        ServerActionMSMQDict = 40,
        InitTimeZone = 41,
        OperatorProfiles = 42,
        MinTableArgsCount = 43,
        TimeZoneConverter = 44,
        TargetIMRServer = 45,
        Session = 46,
        CultureInfoName = 47,
        InitImrEliseDataProvider = 48,
        DistributorHierarchyEnabled = 49
    }

    // #endregion

    // #region DBCollectorLoginParameters

    /**
     * IMR.Suite.Services.WCF.ImrWcfLib.DBCollector
     * */
    export enum DBCollectorLoginParameters {
        Unknown = 0,
        InitDBCollectorProperties = 1,
        InitDBCollectorModule = 2,
        InitAllowedDistributors = 3
    }

    // #endregion

    // #region DeviceConnectionMarkerState

    /**
     * IMR.Suite.Services.WCF.ImrWcfLib.DBCollector
     * */
    export enum DeviceConnectionMarkerState {
        Unknown = 0,
        Retransmitted = 1,
        NotRetransmitted = 2
    }

    // #endregion

    // #region DeviceStateType

    /**
     * IMR.Suite.UI.Business.Objects.CORE.OpDeviceStateType.Enum
     * */
    export enum DeviceStateType {
        NEW = 1,
        IDLE = 2,
        PASSIVE = 3,
        ACTIVE = 4,
        INSPECTED = 5,
        SERVICED = 6,
        ERASED = 7,
        PRODUCED_NOTWORKING = 8,
        PRODUCED_WORKING = 9,
        SENT = 10,
        AFTER_SERVICE = 11,
        PRODUCED_WRONG_CONF = 12,
        STORED_AFTER_SERVICE = 13,
        REMOVED = 14,
        SOT_RECEIVED = 15
    }

    // #endregion

    // #region FileExtension

    /**
     * IMR.Suite.Common.Enums.FileExtension
     * */
    export enum FileExtension {
        Unknown = 0,
        Pdf = 1,
        Xlsx = 2,
        Xls = 3,
        Csv = 4,
        Jpg = 5,
        Png = 6,
        Bmp = 7,
        Log = 8,
        Sql = 9,
        Rtf = 10,
        Svg = 11,
        // Custom
        Jpeg = 100
    }

    // #endregion

    // #region GridOption

    /**
     * IMR.Suite.Common.Enums.GridOption
     * */
    export enum GridOption {
        Unknown = 0,
        Export = 1,
        Import = 2,
        Refresh = 3,
        FullTextSearch = 4,
        AutoFilterRow = 5,
        FitColumns = 6,
        ColumnChooser = 7,
        ColumnConfiguration = 8,

        ProblemConfirmation = 1000,
        PlanDelivery = 1001,
    }

    // #endregion

    // #region ImportInputParamsMode

    /**
     * IMR.Suite.Common.Enums.ImportInputParamsMode
     * */
    export enum ImportInputParamsMode {
        BeforeInitialization = 0,
        BeforeValidation = 1
    }

    // #endregion

    // #region ImportStatus

    /**
     * IMR.Suite.Common.Enums.ImportStatus
     * */
    export enum ImportStatus {
        Unknown = 0,
        NotStarted = 1,
        Succeded = 2,
        Failed = 3,
        InProgress = 4,
        Validated = 5,
        NotValid = 6,
        Loaded = 7,
        Skipped = 8,
        Cancelled = 9
    }

    // #endregion

    // #region IssueStatus

    /**
     * IMR.Suite.UI.Business.Objects.CORE.OpIssueStatus
     * */
    export enum IssueStatus {
        NEW = 1,
        ACCEPTED = 2,
        QUEUED = 3,
        IN_PROGRESS = 4,
        WAITING_FOR_RESPONSE = 5,
        FINISHED = 6,
        SUSPENDED = 7,
        REOPENED = 8,
        CANCELLED = 9,
    }

    // #endregion

    // #region KnownColorsEnum

    // TODO zmienić nazwę po usunięciu tej abominacji poniżej
    /**
     * System.Drawing.KnownColors
     * */
    export enum KnownColorsEnum {
        ActiveBorder = 1,
        ActiveCaption = 2,
        ActiveCaptionText = 3,
        AppWorkspace = 4,
        Control = 5,
        ControlDark = 6,
        ControlDarkDark = 7,
        ControlLight = 8,
        ControlLightLight = 9,
        ControlText = 10,
        Desktop = 11,
        GrayText = 12,
        Highlight = 13,
        HighlightText = 14,
        HotTrack = 15,
        InactiveBorder = 16,
        InactiveCaption = 17,
        InactiveCaptionText = 18,
        Info = 19,
        InfoText = 20,
        Menu = 21,
        MenuText = 22,
        ScrollBar = 23,
        Window = 24,
        WindowFrame = 25,
        WindowText = 26,
        Transparent = 27,
        AliceBlue = 28,
        AntiqueWhite = 29,
        Aqua = 30,
        Aquamarine = 31,
        Azure = 32,
        Beige = 33,
        Bisque = 34,
        Black = 35,
        BlanchedAlmond = 36,
        Blue = 37,
        BlueViolet = 38,
        Brown = 39,
        BurlyWood = 40,
        CadetBlue = 41,
        Chartreuse = 42,
        Chocolate = 43,
        Coral = 44,
        CornflowerBlue = 45,
        Cornsilk = 46,
        Crimson = 47,
        Cyan = 48,
        DarkBlue = 49,
        DarkCyan = 50,
        DarkGoldenrod = 51,
        DarkGray = 52,
        DarkGreen = 53,
        DarkKhaki = 54,
        DarkMagenta = 55,
        DarkOliveGreen = 56,
        DarkOrange = 57,
        DarkOrchid = 58,
        DarkRed = 59,
        DarkSalmon = 60,
        DarkSeaGreen = 61,
        DarkSlateBlue = 62,
        DarkSlateGray = 63,
        DarkTurquoise = 64,
        DarkViolet = 65,
        DeepPink = 66,
        DeepSkyBlue = 67,
        DimGray = 68,
        DodgerBlue = 69,
        Firebrick = 70,
        FloralWhite = 71,
        ForestGreen = 72,
        Fuchsia = 73,
        Gainsboro = 74,
        GhostWhite = 75,
        Gold = 76,
        Goldenrod = 77,
        Gray = 78,
        Green = 79,
        GreenYellow = 80,
        Honeydew = 81,
        HotPink = 82,
        IndianRed = 83,
        Indigo = 84,
        Ivory = 85,
        Khaki = 86,
        Lavender = 87,
        LavenderBlush = 88,
        LawnGreen = 89,
        LemonChiffon = 90,
        LightBlue = 91,
        LightCoral = 92,
        LightCyan = 93,
        LightGoldenrodYellow = 94,
        LightGray = 95,
        LightGreen = 96,
        LightPink = 97,
        LightSalmon = 98,
        LightSeaGreen = 99,
        LightSkyBlue = 100,
        LightSlateGray = 101,
        LightSteelBlue = 102,
        LightYellow = 103,
        Lime = 104,
        LimeGreen = 105,
        Linen = 106,
        Magenta = 107,
        Maroon = 108,
        MediumAquamarine = 109,
        MediumBlue = 110,
        MediumOrchid = 111,
        MediumPurple = 112,
        MediumSeaGreen = 113,
        MediumSlateBlue = 114,
        MediumSpringGreen = 115,
        MediumTurquoise = 116,
        MediumVioletRed = 117,
        MidnightBlue = 118,
        MintCream = 119,
        MistyRose = 120,
        Moccasin = 121,
        NavajoWhite = 122,
        Navy = 123,
        OldLace = 124,
        Olive = 125,
        OliveDrab = 126,
        Orange = 127,
        OrangeRed = 128,
        Orchid = 129,
        PaleGoldenrod = 130,
        PaleGreen = 131,
        PaleTurquoise = 132,
        PaleVioletRed = 133,
        PapayaWhip = 134,
        PeachPuff = 135,
        Peru = 136,
        Pink = 137,
        Plum = 138,
        PowderBlue = 139,
        Purple = 140,
        Red = 141,
        RosyBrown = 142,
        RoyalBlue = 143,
        SaddleBrown = 144,
        Salmon = 145,
        SandyBrown = 146,
        SeaGreen = 147,
        SeaShell = 148,
        Sienna = 149,
        Silver = 150,
        SkyBlue = 151,
        SlateBlue = 152,
        SlateGray = 153,
        Snow = 154,
        SpringGreen = 155,
        SteelBlue = 156,
        Tan = 157,
        Teal = 158,
        Thistle = 159,
        Tomato = 160,
        Turquoise = 161,
        Violet = 162,
        Wheat = 163,
        White = 164,
        WhiteSmoke = 165,
        Yellow = 166,
        YellowGreen = 167,
        ButtonFace = 168,
        ButtonHighlight = 169,
        ButtonShadow = 170,
        GradientActiveCaption = 171,
        GradientInactiveCaption = 172,
        MenuBar = 173,
        MenuHighlight = 174
    }

    // #endregion

    // #region Language

    /**
     * IMR.Suite.Common.Enums.Language
     * */
    export enum Language {
        Unknown = 0,
        Polish = 1,
        English = 2,
        Danish = 3,
        Italian = 4,
        Russian = 5,
        Hebrew = 6,
        Czech = 7,
        Serbian = 8,
        Spanish = 9,
        French = 10,
        EnglishUnitedStates = 11,
        German = 12,
        Default = English
    }

    // #endregion

    // #region LocationStateType

    /**
     * IMR.Suite.UI.Business.Objects.CORE.OpLocationStateType.Enum
     * */
    export enum LocationStateType {
        NEW = 1,
        SCHEDULED = 2,
        INTERVENTION = 3,
        PENDING = 4,
        OPERATIONAL = 5,
        SUSPENDED = 6,
        UNUSED = 7,
        DELETED = 8,
        APPROVED = 9
    }

    // #endregion

    // #region LocationType

    /**
     * IMR.Suite.Common.Enums.LocationType
     * */
    export enum LocationType {
        Unknown = 0,
        CustomerLocation = 1,
        DepositoryLocation = 2,
        ServiceLocation = 3,
        GroupingLocation = 4,
        RelatedLocation = 5,
        DraftLocation = 6,
        UnidentifiedLocation = 7,
        PrepaidAreaLocation = 8,
        PatternLocation = 9,
        DestinationMagazine = 10,
        Truck = 11,
        FuelTerminal = 12,
        WeatherStation = 13,
        NonTelemetricLocation = 14,
        ActionGroupingLocation = 15,
        CountyCapital = 16,
        AreaLocation = 17,
        SgmGroupingLocationType1 = 18,
        SgmGroupingLocationType2 = 19,
        SgmGroupingLocationType3 = 20,
        SgmGroupingLocationType4 = 21,
        SgmGroupingLocationType5 = 22,
        HubLocation = 23,
    }

    // #endregion

    // #region LocationSchemaClass

    /**
     * IMR.Suite.Common.Enums.LocationSchemaClass
     * */
    export enum LocationSchemaClass {
        SimpleXml = 0,
        MXGraph = 1
    }

    // #endregion

    // #region KnownColors

    /**
     * TODO - do zamiany na jakiś normalny enum
     * @deprecated Use KnownColorsEnum
     * */
    export var KnownColors = {
        /* By string */"ActiveBorder": "180,180,180,255", "ActiveCaption": "153,180,209,255", "ActiveCaptionText": "0,0,0,255", "AppWorkspace": "171,171,171,255", "Control": "240,240,240,255", "ControlDark": "160,160,160,255", "ControlDarkDark": "105,105,105,255", "ControlLight": "227,227,227,255", "ControlLightLight": "255,255,255,255", "ControlText": "0,0,0,255", "Desktop": "0,0,0,255", "GrayText": "109,109,109,255", "Highlight": "51,153,255,255", "HighlightText": "255,255,255,255", "HotTrack": "0,102,204,255", "InactiveBorder": "244,247,252,255", "InactiveCaption": "191,205,219,255", "InactiveCaptionText": "0,0,0,255", "Info": "255,255,225,255", "InfoText": "0,0,0,255", "Menu": "240,240,240,255", "MenuText": "0,0,0,255", "ScrollBar": "200,200,200,255", "Window": "255,255,255,255", "WindowFrame": "100,100,100,255", "WindowText": "0,0,0,255", "Transparent": "255,255,255,0", "AliceBlue": "240,248,255,255", "AntiqueWhite": "250,235,215,255", "Aqua": "0,255,255,255", "Aquamarine": "127,255,212,255", "Azure": "240,255,255,255", "Beige": "245,245,220,255", "Bisque": "255,228,196,255", "Black": "0,0,0,255", "BlanchedAlmond": "255,235,205,255", "Blue": "0,0,255,255", "BlueViolet": "138,43,226,255", "Brown": "165,42,42,255", "BurlyWood": "222,184,135,255", "CadetBlue": "95,158,160,255", "Chartreuse": "127,255,0,255", "Chocolate": "210,105,30,255", "Coral": "255,127,80,255", "CornflowerBlue": "100,149,237,255", "Cornsilk": "255,248,220,255", "Crimson": "220,20,60,255", "Cyan": "0,255,255,255", "DarkBlue": "0,0,139,255", "DarkCyan": "0,139,139,255", "DarkGoldenrod": "184,134,11,255", "DarkGray": "169,169,169,255", "DarkGreen": "0,100,0,255", "DarkKhaki": "189,183,107,255", "DarkMagenta": "139,0,139,255", "DarkOliveGreen": "85,107,47,255", "DarkOrange": "255,140,0,255", "DarkOrchid": "153,50,204,255", "DarkRed": "139,0,0,255", "DarkSalmon": "233,150,122,255", "DarkSeaGreen": "143,188,139,255", "DarkSlateBlue": "72,61,139,255", "DarkSlateGray": "47,79,79,255", "DarkTurquoise": "0,206,209,255", "DarkViolet": "148,0,211,255", "DeepPink": "255,20,147,255", "DeepSkyBlue": "0,191,255,255", "DimGray": "105,105,105,255", "DodgerBlue": "30,144,255,255", "Firebrick": "178,34,34,255", "FloralWhite": "255,250,240,255", "ForestGreen": "34,139,34,255", "Fuchsia": "255,0,255,255", "Gainsboro": "220,220,220,255", "GhostWhite": "248,248,255,255", "Gold": "255,215,0,255", "Goldenrod": "218,165,32,255", "Gray": "128,128,128,255", "Green": "0,128,0,255", "GreenYellow": "173,255,47,255", "Honeydew": "240,255,240,255", "HotPink": "255,105,180,255", "IndianRed": "205,92,92,255", "Indigo": "75,0,130,255", "Ivory": "255,255,240,255", "Khaki": "240,230,140,255", "Lavender": "230,230,250,255", "LavenderBlush": "255,240,245,255", "LawnGreen": "124,252,0,255", "LemonChiffon": "255,250,205,255", "LightBlue": "173,216,230,255", "LightCoral": "240,128,128,255", "LightCyan": "224,255,255,255", "LightGoldenrodYellow": "250,250,210,255", "LightGray": "211,211,211,255", "LightGreen": "144,238,144,255", "LightPink": "255,182,193,255", "LightSalmon": "255,160,122,255", "LightSeaGreen": "32,178,170,255", "LightSkyBlue": "135,206,250,255", "LightSlateGray": "119,136,153,255", "LightSteelBlue": "176,196,222,255", "LightYellow": "255,255,224,255", "Lime": "0,255,0,255", "LimeGreen": "50,205,50,255", "Linen": "250,240,230,255", "Magenta": "255,0,255,255", "Maroon": "128,0,0,255", "MediumAquamarine": "102,205,170,255", "MediumBlue": "0,0,205,255", "MediumOrchid": "186,85,211,255", "MediumPurple": "147,112,219,255", "MediumSeaGreen": "60,179,113,255", "MediumSlateBlue": "123,104,238,255", "MediumSpringGreen": "0,250,154,255", "MediumTurquoise": "72,209,204,255", "MediumVioletRed": "199,21,133,255", "MidnightBlue": "25,25,112,255", "MintCream": "245,255,250,255", "MistyRose": "255,228,225,255", "Moccasin": "255,228,181,255", "NavajoWhite": "255,222,173,255", "Navy": "0,0,128,255", "OldLace": "253,245,230,255", "Olive": "128,128,0,255", "OliveDrab": "107,142,35,255", "Orange": "255,165,0,255", "OrangeRed": "255,69,0,255", "Orchid": "218,112,214,255", "PaleGoldenrod": "238,232,170,255", "PaleGreen": "152,251,152,255", "PaleTurquoise": "175,238,238,255", "PaleVioletRed": "219,112,147,255", "PapayaWhip": "255,239,213,255", "PeachPuff": "255,218,185,255", "Peru": "205,133,63,255", "Pink": "255,192,203,255", "Plum": "221,160,221,255", "PowderBlue": "176,224,230,255", "Purple": "128,0,128,255", "Red": "255,0,0,255", "RosyBrown": "188,143,143,255", "RoyalBlue": "65,105,225,255", "SaddleBrown": "139,69,19,255", "Salmon": "250,128,114,255", "SandyBrown": "244,164,96,255", "SeaGreen": "46,139,87,255", "SeaShell": "255,245,238,255", "Sienna": "160,82,45,255", "Silver": "192,192,192,255", "SkyBlue": "135,206,235,255", "SlateBlue": "106,90,205,255", "SlateGray": "112,128,144,255", "Snow": "255,250,250,255", "SpringGreen": "0,255,127,255", "SteelBlue": "70,130,180,255", "Tan": "210,180,140,255", "Teal": "0,128,128,255", "Thistle": "216,191,216,255", "Tomato": "255,99,71,255", "Turquoise": "64,224,208,255", "Violet": "238,130,238,255", "Wheat": "245,222,179,255", "White": "255,255,255,255", "WhiteSmoke": "245,245,245,255", "Yellow": "255,255,0,255", "YellowGreen": "154,205,50,255", "ButtonFace": "240,240,240,255", "ButtonHighlight": "255,255,255,255", "ButtonShadow": "160,160,160,255", "GradientActiveCaption": "185,209,234,255", "GradientInactiveCaption": "215,228,242,255", "MenuBar": "240,240,240,255", "MenuHighlight": "51,153,255,255",
        /* By number */"1": "180,180,180,255", "2": "153,180,209,255", "3": "0,0,0,255", "4": "171,171,171,255", "5": "240,240,240,255", "6": "160,160,160,255", "7": "105,105,105,255", "8": "227,227,227,255", "9": "255,255,255,255", "10": "0,0,0,255", "11": "0,0,0,255", "12": "109,109,109,255", "13": "51,153,255,255", "14": "255,255,255,255", "15": "0,102,204,255", "16": "244,247,252,255", "17": "191,205,219,255", "18": "0,0,0,255", "19": "255,255,225,255", "20": "0,0,0,255", "21": "240,240,240,255", "22": "0,0,0,255", "23": "200,200,200,255", "24": "255,255,255,255", "25": "100,100,100,255", "26": "0,0,0,255", "27": "255,255,255,0", "28": "240,248,255,255", "29": "250,235,215,255", "30": "0,255,255,255", "31": "127,255,212,255", "32": "240,255,255,255", "33": "245,245,220,255", "34": "255,228,196,255", "35": "0,0,0,255", "36": "255,235,205,255", "37": "0,0,255,255", "38": "138,43,226,255", "39": "165,42,42,255", "40": "222,184,135,255", "41": "95,158,160,255", "42": "127,255,0,255", "43": "210,105,30,255", "44": "255,127,80,255", "45": "100,149,237,255", "46": "255,248,220,255", "47": "220,20,60,255", "48": "0,255,255,255", "49": "0,0,139,255", "50": "0,139,139,255", "51": "184,134,11,255", "52": "169,169,169,255", "53": "0,100,0,255", "54": "189,183,107,255", "55": "139,0,139,255", "56": "85,107,47,255", "57": "255,140,0,255", "58": "153,50,204,255", "59": "139,0,0,255", "60": "233,150,122,255", "61": "143,188,139,255", "62": "72,61,139,255", "63": "47,79,79,255", "64": "0,206,209,255", "65": "148,0,211,255", "66": "255,20,147,255", "67": "0,191,255,255", "68": "105,105,105,255", "69": "30,144,255,255", "70": "178,34,34,255", "71": "255,250,240,255", "72": "34,139,34,255", "73": "255,0,255,255", "74": "220,220,220,255", "75": "248,248,255,255", "76": "255,215,0,255", "77": "218,165,32,255", "78": "128,128,128,255", "79": "0,128,0,255", "80": "173,255,47,255", "81": "240,255,240,255", "82": "255,105,180,255", "83": "205,92,92,255", "84": "75,0,130,255", "85": "255,255,240,255", "86": "240,230,140,255", "87": "230,230,250,255", "88": "255,240,245,255", "89": "124,252,0,255", "90": "255,250,205,255", "91": "173,216,230,255", "92": "240,128,128,255", "93": "224,255,255,255", "94": "250,250,210,255", "95": "211,211,211,255", "96": "144,238,144,255", "97": "255,182,193,255", "98": "255,160,122,255", "99": "32,178,170,255", "100": "135,206,250,255", "101": "119,136,153,255", "102": "176,196,222,255", "103": "255,255,224,255", "104": "0,255,0,255", "105": "50,205,50,255", "106": "250,240,230,255", "107": "255,0,255,255", "108": "128,0,0,255", "109": "102,205,170,255", "110": "0,0,205,255", "111": "186,85,211,255", "112": "147,112,219,255", "113": "60,179,113,255", "114": "123,104,238,255", "115": "0,250,154,255", "116": "72,209,204,255", "117": "199,21,133,255", "118": "25,25,112,255", "119": "245,255,250,255", "120": "255,228,225,255", "121": "255,228,181,255", "122": "255,222,173,255", "123": "0,0,128,255", "124": "253,245,230,255", "125": "128,128,0,255", "126": "107,142,35,255", "127": "255,165,0,255", "128": "255,69,0,255", "129": "218,112,214,255", "130": "238,232,170,255", "131": "152,251,152,255", "132": "175,238,238,255", "133": "219,112,147,255", "134": "255,239,213,255", "135": "255,218,185,255", "136": "205,133,63,255", "137": "255,192,203,255", "138": "221,160,221,255", "139": "176,224,230,255", "140": "128,0,128,255", "141": "255,0,0,255", "142": "188,143,143,255", "143": "65,105,225,255", "144": "139,69,19,255", "145": "250,128,114,255", "146": "244,164,96,255", "147": "46,139,87,255", "148": "255,245,238,255", "149": "160,82,45,255", "150": "192,192,192,255", "151": "135,206,235,255", "152": "106,90,205,255", "153": "112,128,144,255", "154": "255,250,250,255", "155": "0,255,127,255", "156": "70,130,180,255", "157": "210,180,140,255", "158": "0,128,128,255", "159": "216,191,216,255", "160": "255,99,71,255", "161": "64,224,208,255", "162": "238,130,238,255", "163": "245,222,179,255", "164": "255,255,255,255", "165": "245,245,245,255", "166": "255,255,0,255", "167": "154,205,50,255", "168": "240,240,240,255", "169": "255,255,255,255", "170": "160,160,160,255", "171": "185,209,234,255", "172": "215,228,242,255", "173": "240,240,240,255", "174": "51,153,255,255"
    }

    // #endregion

    // #region MapInteractionType

    /**
     * IMR.Suite.Common.Enums
     * */
    export enum MapInteractionType {
        MarkerBounce = 0,
        MarkerFilter = 1
    }

    // #endregion

    // #region MapProvider

    /**
     * IMR.Suite.Common.Enums.MapProvider
     * */
    export enum MapProvider {
        OpenStreetMap = 0,
        GoogleLeaflet = 1,
        GoogleMap = 2,
        SmartGeomatic = 3
    }

    // #endregion

    // #region MeasurementViewStyle
    /**
     *  IMR.Suite.Services.WCF.ImrWcfLib.DBCollector.MeasurementViewStyle
     */
    export enum MeasurementViewStyle {
        DataInColumns = 1,
        DataInRows = 2
    }

    // #endregion

    // #region MeterType

    /**
     * IMR.Suite.Common.Enums.MeterType
     * */
    export enum MeterType {
        SMART_SERV_PRO = 2105,
    }

    // #endregion

    // #region Module

    /**
     * IMR.Suite.Common.Enums.Module
     * */
    export enum Module {
        Unknown = 0,

        WebSIMAX = 50,
    }

    // #endregion

    // #region NotificationDeliveryType

    /**
     * IMR.Suite.Common.Enums.NotificationDeliveryType
     * */
    export enum NotificationDeliveryType {
        SMS = 1,
        GCM = 2,
        EMail = 3
    }

    // #endregion

    // #region ObjectHistoryEventType

    /**
     * IMR.Suite.Common.Enums.ObjectHistoryEventType
     * */
    export enum ObjectHistoryEventType {
        ShippedToClient = 1,
        ApprovedForService = 2,
        ServicePerformed = 3,
        InstalledAtLocation = 4,
        RemovedFromLocation = 5,
        AddedToPackage = 6,
        ReceivedByFitter = 7,
        DeinstalledByFitter = 8,
        RelatedWithTask = 9,
        SimCardAssigned = 10,
        SimCardRemoved = 11,
        SendToServer = 12,
        ChangedStatus = 13,
        RelatedWithIssue = 14,
        ChangedEquipment = 15,
        StepPerformed = 16,
        ReportGenerated = 17,
    }

    // #endregion

    // #region OpChangeState

    /**
     * IMR.Suite.UI.Business.Objects.IOpChangeState
     * */
    export enum OpChangeState {
        Undefined = 0,
        New = 1,
        Modified = 2,
        Loaded = 3,
        Delete = 4,
        Incorrect = 5,
    }

    // #endregion

    // #region PackageStatus

    /**
     * IMR.Suite.Common.PackageStatus
     * */
    export enum PackageStatus {
        New = 1,
        Sent = 2,
        Wrong = 3,
        Accepted = 4,
        Distributed = 5,
        Expired = 6,
        Removed = 7,
        NewOrder = 8,
        Ordered = 9,
        ToCompletion = 10,
        InCompletion = 11,
        OrderPartiallyCompleted = 12,
        OrderCompleted = 13,
        OrderRemoved = 14
    }

    // #endregion

    // #region PaymentModule
    /**
     * IMR.Suite.Common.Enums.PaymentModule
     * */

    export enum PaymentModule {
        Unknown = 0,
        SGM = 1,
        TMUserPortal = 2,
        OrangePL_SMS = 3,
        OrangePL_USSD = 4,
        OrangePL_Ofin = 5,
        Billing = 6,
        MobilePOS = 7,
        SmartGas = 8,
        SSLCommerz = 9,
        WebSIMAX = 10,
        Paytm = 11,
        BKash = 12,
        IGLPaymentGateway = 13
    }

    // #endregion

    // #region RouteStatus

    /**
     * IMR.Suite.UI.Business.Objects.CORE.OpRouteStatus
     * */
    export enum RouteStatus {
        UNKNOWN = 0,
        PLANNED = 1,
        COMMITTED = 2,
        IN_PROGRESS = 3,
        FINISHED = 4,
        CLOSED = 5,
        DOWNLOADED = 6,
        UPLOADED = 7,
        ACCOMPLISHED = 8,
        CANCELLED = 9
    }

    // #endregion

    // #region ProblemClass

    /**
     * IMR.Suite.Common.Enums.ProblemClass
     * */
    export enum ProblemClass {
        ProbeDrowned = 1,
        ProbeHang = 2,
        SingleLoss = 3,
        SingleSurplus = 4,
        SingleSurplusWaterInflux = 5,
        SingleSurplusMicromixing = 6,
        PermanentLossFuelLeak = 7,
        PermanentLossInnerLeak = 8,
        PermanentLossNozzleDecalibration = 9,
        PermanentSurplusWaterInflux = 10,
        PermanentSurplusInnerLeak = 11,
        PermanentSurplusNozzleDecalibration = 12,
        CalibrationCurveError = 13,
        FuelHighLevel = 14,
        FuelLowLevel = 15,
        Deadstock = 16,
        WaterHighLevel = 17,
        SirenFailed = 18,
        Density = 19,
        Overfill = 20,
        FuelLeakageDW = 21,
        FuelLeakageP = 22,
        //PermanentLossFuelLeak = 23,
        //PermanentSurplusInnerLeak = 24,
        UnderCountingGasMeter = 25,
        OverCountingGasMeter = 26,
        CounterMalfunction = 27,
        NoProblem = 28,
        IllegalDelivery = 29,
        TooSmallDetectedDelivery = 30,
        TooLargeDetectedDelivery = 31,
        PermanentSurplus = 32,
        PermanentLoss = 33,
        IrcSir2Loss = 34,
        ConstantLevel = 35,
        ProbeFailure = 36,
        DispenserFailure = 37,
        ATGSensorLiquid = 38,
        ATGSensorVapor = 39,
        MissingAlevelData = 40,
        InvalidAlevelData = 41,
        MissingOKOPacket = 42,
        StockOutRisk = 43,
        Overfill2 = 44,
        LostSaleByStockOut = 45,
        LateDelivery = 46,
        LateDeliveryRisk = 47,

        //New Problems frm ACO DecisionModule for bottle switcher
        MissingData = 48,
        FaultyDevice = 49,
        LostBankDetection = 50,
        UnauthorisedCylinderExchanged = 51,
        EarlyDelivery = 52,
        DeliveryOverdue = 53,
        NoDeliveryPlanned = 54,
        HumanInterferenceLeftToRightKnobChanged = 55,
        HumanInterferenceRightToLeftKnobChanged = 56,
        LeftBankActiveWithEmptySites = 57,
        RightBankActiveWithEmptySites = 58,
        LeftBankActiveNoDeliveryDetected = 59,
        RightBankActiveNoDeliveryDetected = 60,
        TotalCounterReset = 61,
        SuspicionOfALeakage = 62,
        DispenserFailureLON = 63,
        DispenserFailureDOMS = 64,
        ATGFailure = 65,
        NozzleCalibrationError = 66,
    }

    //#endregion

    // #region ReferenceType

    /**
     * IMR.Suite.Common.Enums.ReferenceType
     * */
    export enum ReferenceType {
        None = 0,
        IdOperator = 1,
        IdAtgType = 2,
        IdReport = 3,
        IdReportDataType = 4,
        IdDataType = 5,
        SerialNbr = 6,
        IdMeter = 7,
        IdLocation = 8,
        IdProductCode = 9,
        IdDeviceDriver = 10,
        IdDistributor = 11,
        IdDelivery = 12,
        IdMeterType = 13,
        IdDeviceType = 14,
        IdValveState = 15,
        IdIssueStatus = 16,
        IdIssueType = 17,
        IdTaskStatus = 18,
        IdTaskType = 19,
        IdRoute = 20,
        IdRouteStatus = 21,
        IdRole = 22,
        /// <summary>
        /// Lista ID_OPERATOR podawana jako string: 1;2;45;678
        /// </summary>
        OperatorList = 23,
        /// <summary>
        /// dopisać do DB, podawana jako nazwa typu akcji w formacie SMS_GET_DATA
        /// </summary>
        ActionType = 24,
        IdLanguage = 25,
        IdIMRServer = 26,
        IdFile = 27,
        IdDataSourceType = 28,
        IdActionDef = 29,
        IdProfile = 30,
        IdSlotType = 31,
        IdDetailView = 32,
        IdModule = 33,
        IdActivity = 34,
        IdCommandCodeType = 35,
        IdActionSmsText = 36,
        IdDepot = 37,
        IdDeliveryAdvice = 38,
        IdLocationStateType = 39,
        IdLocationType = 40,
        IdAggregationType = 41,
        IdConfigurationProfile = 42,
        IdTariff = 43,
        IdWMBUSTransmissionType = 44,
        IdMeterTypeGroup = 45,
        IdDescr = 46,
        IdSupplier = 47,
        IdAlarmText = 48,
        IdDeviceDashboardMainChartView = 49,
        IdDeviceDashboardAdditionalChartView = 50,
        IdMeterTypeClass = 51,
        IdFileExtension = 52,
        IdDeviceStateType = 53,
        /// <summary>
        /// Lista ID_TASK_STATUS podawana jako string: 1;2;45;678
        /// </summary>
        TaskStatusList = 54,
        IdGross = 55,
        IdNet = 56,
        IdReportType = 57,
        IdFaultCode = 58,
        IdTransmissionType = 59,
        IdUIObjectProperties = 60,
        IdDataFormatGroup = 61,
        IdArticle = 62,
        IdTaskGroup = 63,
        IdFileType = 64,
        IdIssue = 65,
        IdTask = 66,
        IdReferenceType = 67,
        IdMapMarkerTextType = 68,
        IdTransmissionDriver = 69,
        IdSimCard = 70,
        SITAUIObjectProperties = 71,
        IdVersion = 72,
        IdActor = 73,
        IdDeviceTypeGroup = 74,
        IdEtl = 75,
        IdOperatorLoginStatus = 76,
        TextValue = 77,
        IdDepositoryElement = 78,
        IdDeviceOrderNumber = 79,
        IdRefuel = 80,
        IdUnit = 81,
        IdSitaCommandType = 82,
        IdEmailSendingMode = 83,
        IdVersionState = 84,
        IdIssueGroup = 85,
        IdPriority = 86,
        IdSitaFitterDeposiotryMode = 87,
        IdAlarm = 88,
        IdAlarmGroup = 89,
        IdAlarmStatus = 90,
        IdRouteType = 91,
        IdRouteDef = 92,
        IdChartType = 93,
        IdView = 94,
        IdAlarmType = 95,
        IdAlarmDef = 96,
        IdDataArch = 97,
        IdFuelFillingPointType = 98,
        IdDispenserPumpType = 99,
        IdStationType = 100,
        IdStationProfileType = 101,
        IdAction = 102,
        IdActorGroup = 103,
        IdVersionElement = 104,
        IdViewColumn = 105,
        IdProtocol = 106,
        IdActionStatus = 107,
        IdDatabaseType = 108,
        LocationList = 109,
        IdDeviceInstalationPlace = 110,
        IdDeviceLocationCompassDirection = 111,
        IdDeviceConnection = 112,
        IdSitaInstallationFormType = 113,
        IdAlarmEvent = 114,
        DistributorList = 115,
        MeterTypeList = 116,
        DeviceTypeList = 117,
        AreaList = 118,
        IdDataTypeGroup = 119,
        IdDataTypeInGroup = 120,
        IdTaskTypeGroup = 121,
        IdCurrency = 122,
        IdPackage = 123,
        IdPackageStatus = 124,
        Color = 125,
        IdReportScheduleMode = 126,
        IdGridOption = 127,
        IdDeviceTypeInstallationWay = 128,
        IdMobileNetworkCode = 129,
        IdDataTypeClass = 130,
        IdDataTypeFormat = 131,
        IdDataFormatGroupDetails = 132,
        IdTextAlign = 133,
        IdMobilePlugin = 134,
        IdConnection = 135,
        IdLocationSchemaType = 136,
        IdConsumerType = 137,
        IdConsumer = 138,
        IdKpiSourceSystem = 139,
        IdDistributorHierarchy = 140,

        IdMeterAcoChangeoverPressureRegulatorType = 146,

        Month = 152,

        IdPaymentModule = 155,

        IdConsumerTransaction = 160,
        IdConsumerTransactionType = 161,
        IdConsumerSettlement = 162,
        IdLocationEquipment = 163,
        IdConfigurationCode = 164,

        IdOperatorGroup = 166,

        IdTechnicalPermission = 170,
        IdUniversalDigitalInputConfiguration = 171,

        IdLocationInstallationCategory = 176,

        SSRSRenderFormat = 180,

        IdLocationFieldElement = 196,
        IdLocationProjectType = 197,
        IdDeviceUdiDescription = 198
    }

    // #endregion

    // #region ReportType

    /**
     * IMR.Suite.Common.Enums.ReportType
     * */
    export enum ReportType {
        Unknown = 0,
        MeasuresReport = 1,
        PredefinedOnStoredProcedure = 2,
        FileReport = 3,
        PlipA = 4,
        PlipB = 5,
        PlipC = 6,
        JobReport = 7,
        ServerReportingServices = 8
    }

    // #endregion

    // #region RouteType

    /**
     * IMR.Suite.Common.Enums.RouteType
     * */
    export enum RouteType {
        UNKNOWN = 0,
        READOUT = 1,
        INSTALLATION = 2,
        SERVICE = 3,
        DELIVERY = 4
    }

    // #endregion

    // #region RunActionResult

    /**
     * IMR.Suite.Common.Enums.RunActionResult
     * */
    export enum RunActionResult {
        OK = 0,
        Exception = 1,
        MSMQNotInstalled = 2,
        MSMQParamsNotFound = 3,
        CouldNotRunAction = 4,
        MappingNotFound = 5
    }

    // #endregion

    // #region Tables

    /**
     * IMR.Suite.Common.Enums.Tables
     * */
    export enum Tables {
        UNKNOWN = 1000000,

        DATA = 0,

        DEVICE = 1,
        DEVICE_STATE_TYPE = 2,
        DEVICE_TYPE = 3,
        DEVICE_TYPE_CLASS = 4,
        DEVICE_STATE_HISTORY = 5,
        DEVICE_HIERARCHY = 6,
        DEVICE_DRIVER = 8,
        DEVICE_ORDER_NUMBER = 9,
        DEVICE_PATTERN = 100,

        SLOT_TYPE = 10,
        PROTOCOL = 11,
        PROTOCOL_DRIVER = 12,

        DISTRIBUTOR = 30,
        DISTRIBUTOR_PERFORMANCE = 31,
        DISTRIBUTOR_DATA = 32,

        METER = 40,
        METER_TYPE = 41,
        METER_TYPE_CLASS = 42,

        LOCATION = 50,
        LOCATION_TYPE = 51,
        LOCATION_STATE_TYPE = 52,
        LOCATION_EQUIPMENT = 53,
        LOCATION_STATE_HISTORY = 54,
        LOCATION_HIERARCHY = 55,

        SIM_CARD = 60,
        DEVICE_SIM_CARD_HISTORY = 61,
        SIM_CARD_DATA = 62,

        LANGUAGE = 70,
        DESCR = 71,
        PRIORITY = 72,

        TASK = 110,
        TASK_GROUP = 111,
        TASK_STATUS = 112,
        TASK_TYPE = 113,
        TASK_TYPE_GROUP = 114,
        TASK_HISTORY = 115,
        TASK_DATA = 116,

        ISSUE = 120,
        ISSUE_TYPE = 121,
        ISSUE_STATUS = 122,
        ISSUE_HISTORY = 123,

        ROUTE = 130,
        ROUTE_POINT = 131,
        ROUTE_DATA = 132,

        OPERATOR = 140,
        OPERATOR_DATA = 141,
        OPERATOR_ROLE = 142,

        DATA_TEMPORAL = 150,

        ACTOR = 160,
        ACTOR_GROUP = 161,
        ACTOR_IN_GROUP = 162,

        ARTICLE = 170,

        DEPOSITORY_ELEMENT = 180,

        SHIPPING_LIST = 200,
        SHIPPING_LIST_DATA = 201,
        SHIPPING_LIST_DEVICE = 202,
        SHIPPING_LIST_TYPE = 203,

        SERVICE_LIST = 210,
        SERVICE_LIST_DATA = 211,
        SERVICE_LIST_DEVICE = 212,
        SERVICE_LIST_DEVICE_DATA = 213,
        SERVICE_LIST_DEVICE_ACTION = 214,
        SERVICE_ACTION_RESULT = 215,
        SERVICE_LIST_DEVICE_ACTION_DETAILS = 216,
        SERVICE_LIST_DEVICE_DIAGNOSTIC = 217,
        SERVICE = 218,
        SERVICE_DATA = 219,
        SERVICE_PACKAGE = 220,
        SERVICE_PACKAGE_DATA = 221,
        SERVICE_IN_PACKAGE = 222,
        SERVICE_SUMMARY = 223,
        SERVICE_SUMMARY_DATA = 224,
        SERVICE_REFERENCE_TYPE = 225,
        SERVICE_DIAGNOSTIC_RESULT = 226,
        DIAGNOSTIC_ACTION = 227,
        DIAGNOSTIC_ACTION_DATA = 228,
        DIAGNOSTIC_ACTION_RESULT = 229,
        COMPONENT = 230,

        REPORT = 250,
        REPORT_DATA = 251,
        REPORT_PERFORMANCE = 252,

        IMR_SERVER_PERFORMANCE = 260,

        TRANSMISSION_DRIVER = 270,
        TRANSMISSION_DRIVER_PERFORMANCE = 271,
        TRANSMISSION_DRIVER_DATA = 272,

        DATA_TRANSFER = 280,

        CODE = 290,

        AUDIT = 300,
        DATA_TYPE = 301,
        DATA_TYPE_GROUP = 302,
        DATA_TYPE_IN_GROUP = 303,

        UNIT = 304,

        ETL = 350,
        ETL_PERFORMANCE = 351,

        ROLE = 360,
        ROLE_ACTIVITY = 361,

        REFUEL = 370,
        REFUEL_DATA = 371,

        DATA_ARCH = 400,
        PROFILE = 401,
        PRODUCT_CODE = 402,
        PROFILE_DATA = 403,
        CONFIGURATION_PROFILE = 404,
        ACTIVITY = 405,
        ACTION = 406,
        ACTION_DATA = 407,
        MODULE = 408,
        ISSUE_DATA = 409,
        DEVICE_DISTRIBUTOR_HISTORY = 410,
        DEVICE_WARRANTY = 411,
        DATA_TEMPORTAL = 412,
        ROUTE_TYPE = 413,
        ROUTE_STATUS = 414,
        ALARM = 415,
        ALARM_DATA = 416,
        ALARM_DEF = 417,
        ALARM_DEF_GROUP = 418,
        ALARM_EVENT = 419,
        ALARM_GROUP = 420,
        ALARM_GROUP_OPERATOR = 421,
        ALARM_HISTORY = 422,
        ALARM_MESSAGE = 423,
        ALARM_STATUS = 424,
        ALARM_TEXT = 425,
        ALARM_TEXT_DATA_TYPE = 426,
        ALARM_TYPE = 427,
        IMR_SERVER = 428,
        TRANSMISSION_TYPE = 429,
        DEVICE_CONNECTION = 430,
        TARIFF = 431,
        TARIFF_DATA = 432,

        VIEW = 500,
        VIEW_COLUMN = 501,
        VIEW_COLUMN_DATA = 502,
        VIEW_COLUMN_SOURCE = 503,
        VIEW_COLUMN_TYPE = 504,
        VIEW_DATA = 505,

        PACKAGE = 550,
        PACKAGE_DATA = 551,
        PACKAGE_STATUS_HISTORY = 552,

        DEVICE_ORDER_NUMBER_DATA = 553,

        DEDICATED_DISTRIBUTOR_LOCATION_GROUPS = 1000,
    }

    // #endregion

    // #region TaskPaymentPartType

    /**
     * IMR.Suite.Common.Enums.TaskPaymentPartType
     * */
    export enum TaskPaymentPartType {
        //Fitter < 1000
        FitterBase = 1,
        FitterPremium = 2,
        FitterRevisit = 3,
        FitterSecondSetInstallation = 4,//instalacja drugiego zestawu na lokalziacji, czasami inna kwota wynikająca z umowy
        FitterInstallationAberdeenArea = 5,//instalacja w rejonie Aberdeen - umowa Avanti
        FitterAberdeenAreaSecondSetInstallation = 6,
        FitterSetInstallation = 7,

        //Client >= 1000
        ClientBase = 1000,
        ClientDevice = 1001,//per urządzenie zamontowane w zadaniu
        ClientInstallationTransitAccomoodataion = 1002,//przejazy, zakwaterowanie serwisanta podczas instalacji
        ClientTankMonitoringHardwareRemoval = 1003,
        ClientOKOX303SmartMeterPlugInUnitRemoval = 1004,
        ClientSecondSetInstallation = 1005,//instalacja drugiego zestawu na lokalziacji, czasami inna kwota wynikająca z umowy
        ClientInstallationAberdeenArea = 1006,//instalacja w rejonie Aberdeen - umowa Avanti
        ClientAberdeenAreaSecondSetInstallation = 1007,
        ClientSetInstallation = 1008,
        ClientSimCardActivation = 1009,
        ClientServiceTransitAccomoodataion = 1010,//przejazy, zakwaterowanie serwisanta podczas serwisu
        ClientServiceAberdeenArea = 1011,//Serwis Aberdeen 
        ClientServiceNotCoveredByFlatFee = 1012,//Serwis serwis nie objęty stałą opłatą 
        ClientServiceHardwarePenalty = 1013,//Kara za opóźnienia podczas serwisu dotyczącego Hardware
        ClientServiceSoftwarePenalty = 1014,//Kara za opóźnienia podczas serwisu dotyczącego Software
        ClientSetInstallationPremium = 1015, // to samo co 1008 ale premium
        ClientSecondSetInstallationPremium = 1016, //instalacja drugiego zestawu na lokalziacji, czasami inna kwota wynikająca z umowy (premium)
        ClientSetInstallationAberdeenAreaPremium = 1017 //instalacja w rejonie Aberdeen - umowa Avanti (premium)
    }

    // #endregion

    // #region TaskPaymentType

    /**
     * IMR.Suite.Common.Enums.TaskPaymentType
     * */
    export enum TaskPaymentType {
        Fitter = 1,
        Client = 2,
    }

    // #endregion

    // #region TaskStatus

    /**
     * IMR.Suite Business\UI.Business.Objects\Objects\CORE\OpTaskStatus.cs
     * */
    export enum TaskStatus {
        Unknown = 0,
        Not_Started = 1,
        In_progress = 2,
        WaitingForAcceptance = 3,
        Finished_succesfully = 4,
        Finished_with_error = 5,
        Planned = 6,
        Canceled = 7,
        Suspended = 8,
        Verified = 9,
        RealizationNotPossible = 10,
        Rejected = 11,
        Aborted = 12,
    }

    // #endregion

    // #region TypeDateTimeCodeModeType

    /**
     * IMR.Suite.Data.DB.TypeDateTimeCode.ModeType
     * */
    export enum TypeDateTimeCodeModeType {
        None = -1,
        Null = 0,
        Between = 1,
        Different = 2,
        Equal = 3,
        Lesser = 4,
        LesserEqual = 5,
        GreaterEqual = 6,
        Greater = 7,
    }

    // #endregion

    // #region SchemaElementType

    /**
     * IMR.Suite.Common.SchemaElementType
     * */
    export enum SchemaElementType {
        Unknown = 0,
        StandardInput = 1,
        Redirection = 2,
    }

    // #endregion

    // #region SESSION_STATUS

    /**
     * IMR.Suite.Services.WCF.ImrWcfLib
     * */
    export enum SESSION_STATUS {
        OK,
        SESSION_ALREADY_STARTED,
        LOGIN_NOT_VALID,
        SESSION_NOT_VALID,
        PWD_VALIDATION_FAILED,
        ERROR,
    }

    // #endregion

    // #region SimaxConfigSection

    /**
     * 
     * */
    export enum SimaxConfigSection {
        Icons = 0,
        Languages = 1,
        Map = 2,
        RtlState = 3,
        Themes = 4,
        Grid = 5,
        Authentication = 6,
        Api = 7,
        Debug = 8,
        DebugSchema = 9,
        Route = 10,
        GalleryType = 11,
        ReportViewer = 12,
        LocationValidationPageSize = 13,
        Formats = 14,
        Charts = 15,
        Schema = 16,
        Owner = 17,
        LoginScreenTheme = 18,
        Windows10CompatibileHidden = 19,
        DbCollector = 20,
        Resources = 21,
    }

    // #endregion

    // #region SimaxCreateEditSelectedTabType

    /**
     * 
     * */
    export enum SimaxCreateEditSelectedTabType {
        Unknown = -1,
        BaseParameters = 0,
        ExtendedParameters = 1,
    }

    // #endregion

    // #region SimaxDataTypeGroupCategory

    /**
     * IMR.Suite.Common.Enums.DataTypeGroup
     * */
    export enum SimaxDataTypeGroupCategory {
        //Grupy charakterystyczne dla danego okienka z identyfikatorem rozpoczynającym się od 1000
        Unknown = 0,
        WEBSIMAX__MODULE_NAME__GRID_PARAMS = 1,
        WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS = 2,
        WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_DISPLAY = 3,
        WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_EDIT = 4,
        WEBSIMAX__MODULE_NAME__PREVIEW_PANEL_PARAMS = 5,
        WEBSIMAX__MODULE_NAME__PARAMS_REQUIRED = 6,
        WEBSIMAX__MODULE_NAME__GRID_PARAMS_TO_DISPLAY = 7,
        WEBSIMAX__MODULE_NAME__GRID_PARAMS_TO_EDIT = 8,
        WEBSIMAX__MODULE_NAME__MEASUREMENTS = 9,
        WEBSIMAX__MODULE_NAME__IMPORT_PARAMS = 10,
        WEBSIMAX__MODULE_NAME__POPUP_GRID_PARAMS = 11,
        WEBSIMAX__MODULE_NAME__GROUP_GRID_PARAMS = 1000,
        WEBSIMAX__MODULE_NAME__LOCATION_GRID_PARAMS = 1001,
        WEBSIMAX__MODULE_NAME__CONTENT_GRID_PARAMS = 1002,
        WEBSIMAX__MODULE_NAME__ASSIGNED_LOCATION_GRID_PARAMS = 1003,
        WEBSIMAX__MODULE_NAME__INSTALLED_DEVICES_GRID_PARAMS = 1004,
        WEBSIMAX__MODULE_NAME__UNINSTALLED_DEVICES_GRID_PARAMS = 1005,
        WEBSIMAX__MODULE_NAME__TRANSACTIONS_DEFAULT_GRID_PARAMS = 1006,
        WEBSIMAX__MODULE_NAME__TRANSACTIONS_GRID_PARAMS = 1007,
        WEBSIMAX__MODULE_NAME__LOCATION_PANEL_PARAMS_TO_DISPLAY = 1008,
        WEBSIMAX__MODULE_NAME__LOCATION_PANEL_PARAMS_TO_EDIT = 1009,
        WEBSIMAX__MODULE_NAME__LOCATION_PARAMS_REQUIRED = 1010,
        WEBSIMAX__MODULE_NAME__TASK_GRID_PARAMS = 1011,
        WEBSIMAX__MODULE_NAME__OPERATOR_GRID_PARAMS = 1012,
        WEBSIMAX__MODULE_NAME__DEF_REF_PARAMS = 1013,
        WEBSIMAX__MODULE_NAME__DEVICE_GRID_PARAMS = 1014,
        WEBSIMAX__MODULE_NAME__ALARM_DEF_PARAMS = 1015,
        WEBSIMAX__MODULE_NAME__ALARM_DEF_REF_PARAMS = 1016,
        WEBSIMAX__MODULE_NAME__ALARM_DEF_PANEL_PARAMS = 1017,
        WEBSIMAX__MODULE_NAME__METER_GRID_PARAMS = 1018,
        WEBSIMAX__MODULE_NAME__COPY_SKIP_PARAMS = 1019
    }

    // #endregion

    // #region SimaxDedicatedCreateEditForm

    export class SimaxDedicatedCreateEditForm {
        public static KINGSPAN = 'locations-create-edit-kingspan'
    }

    // #endregion

    // #region SimaxEventCategory

    /**
     * 
     * */
    export enum SimaxEventCategory {
        //Grupy charakterystyczne dla danego okienka z identyfikatorem rozpoczynającym się od 1000

        Unknown = 0,

        _MODULE_NAME__OPEN_DETAILS_POPUP = 1,
        _MODULE_NAME__OPEN_CREATE_EDIT_POPUP = 2,
        _MODULE_NAME__OPEN_DELETE_CONFIRMATION_POPUP = 3,
        _MODULE_NAME__CLOSE_DETAILS_POPUP = 4,
        _MODULE_NAME__CLOSE_CREATE_EDIT_POPUP = 5,
        _MODULE_NAME__CLOSE_DELETE_CONFIRMATION_POPUP = 6,
        _MODULE_NAME__CONFIRM_DELETE_CONFIRMATION_POPUP = 7,
        _MODULE_NAME__DELETED = 8,
        _MODULE_NAME__OPEN_BULK_EDIT_POPUP = 9,
        _MODULE_NAME__REFRESH = 10,

        _MODULE_NAME__CONFIRMED = 1000,
    }

    // #endregion

    // #region SimaxLocalizationCategory

    /**
     * 
     * */
    export enum SimaxLocalizationCategory {
        //Grupy charakterystyczne dla danego okienka z identyfikatorem rozpoczynającym się od 1000
        Unknown = 0,
        _MODULE_NAME__DELETING = 1,
        _MODULE_NAME__DELETED = 2,
        _MODULE_NAME__DELETE_ERROR = 3,
        _MODULE_NAME__SAVED = 4,
        _MODULE_NAME__SAVE_ERROR = 5,
        _MODULE_NAME__ADDING = 6,
        _MODULE_NAME__EDITING = 7,
        _MODULE_NAME__DETAILS = 8,
        _MODULE_NAME__MASS_EDITING = 9,
        _MODULE_NAME__NAME = 10,
        _MODULE_NAME__CURRENT = 11,
        _MODULE_NAME__AVAILABLE = 12,
        _MODULE_NAME__CONFIRM_DELETE = 13,
        _MODULE_NAME__EXPORT = 14,
        _MODULE_NAME__IMPORT = 15,
        _MODULE_NAME__COPY = 16,
        _MODULE_NAME__COPYING = 17,
        _MODULE_NAME__ADD = 18,
        _MODULE_NAME__EDIT = 19,
        _MODULE_NAME__ASSIGN = 20,
        _MODULE_NAME__SHOW = 21,
        _MODULE_NAME__SHOW_DETAILS = 22,
        _MODULE_NAME__CONFIRM_BULK_DELETE = 23,

        _MODULE_NAME__CONTENT_EDITING = 1004,
        _MODULE_NAME__CONTENT = 1005,
        _MODULE_NAME__EDIT_CONTENT = 1006,
        _MODULE_NAME__GENERATE = 1007,
        _MODULE_NAME__GROUPS_EDIT = 1008,
        _MODULE_NAME__LOCATIONS_EDIT = 1009,
        _MODULE_NAME__REQUIRED_TECHNICAL_PERMISSIONS_EDIT = 1010,
        _MODULE_NAME__CHILDREN = 1011,
        _MODULE_NAME__CHILDREN_EDITING = 1012,
        _MODULE_NAME__MIN_STATES = 1013,
        _MODULE_NAME__MIN_STATES_EDITING = 1014,
        _MODULE_NAME__TECHNICAL_PERMISSIONS = 1015,
        _MODULE_NAME__TECHNICAL_PERMISSIONS_EDITING = 1016,
        _MODULE_NAME__DEVICES_EDIT = 1017,
        _MODULE_NAME__SAVED_COUNT = 1018,
        _MODULE_NAME__SUPPLIERS = 1019,        
    }

    // #endregion

    // #region SimaxMapAreaType

    /**
     * 
     * */
    export enum SimaxMapAreaType {
        Unknown,
        Marker,
        Polygon,
        Range
    }

    // #endregion

    // #region SimaxMarkerEvent

    /**
     * 
     * */
    export enum SimaxMarkerEvent {
        Unknown,
        Click
    }

    // #endregion

    // #region SimaxIconSize

    /**
     * 
     * */
    export enum SimaxIconSize {
        Small = 0,
        Normal = 1,
        Large = 2
    }

    // #endregion

    // #region SimaxModuleName

    /**
     * 
     * */
    export enum SimaxModuleName {
        Unknown = 0,
        Actor = 1,
        Alarm = 2,
        Device = 3,
        Depository = 4,
        Distributor = 5,
        Meter = 6,
        Operator = 7,
        Issue = 8,
        Task = 9,
        Route = 10,
        Sim_Card = 11,
        Report = 12,
        Action = 13,
        Device_Connection = 14,
        Script = 15,
        Settings = 16,
        Location = 17,
        Grouping_Location = 18,
        Grouping_Location_Type = 19,
        Cashier_Panel = 20,
        Consumer = 21,
        Task_Type = 22,
        Alarm_Group = 23,
        Operator_Group = 24,
        Tariff = 25,
        Consumer_Type = 26,
        Meter_Alarm = 27,
        Order = 28,
        Package = 29,
        Payment = 30,
        Supplier = 31
    }

    // #endregion

    // #region SimaxOperatorSetting

    /**
     * IMR.Suite.Common.DataType
     * Identyfikatory tożsame z IdDataType pobierane z OperatorSettings
     * */
    export enum SimaxOperatorSetting {
        Unknown = 0,
        //Identyfikatory tożsame z IdDataType pobierane z OperatorSettings
        ActiveViews = 10229,
        CurrentLanguage = 10082,
        DateFormatShort = 22312,
        DateFormatLong = 22311,
        DictionaryCompleteness = 10147,
        DictionaryVersion = 7008,
        DistributorHierarchyEnabled = 10250,
        ExportPlugin = 17707,
        ImportPlugin = 17691,
        ImrEvaVersion = 4720,
        ImrEvaDb = 4723,
        ImrServerId = 3861,
        MapZoomDefaultGoogle = 10206,
        MarkerCustomFormatStringMeter = 22356,
        MarkerCustomFormatStringDevice = 22357,
        Layout = 3982,
        Logo = 17700,
        LoggedOperator = 10032,
        ObjectCustomFormatStringLocation = 22259,
        ObjectCustomFormatStringDevice = 22260,
        ObjectCustomFormatStringMeter = 22261,
        ObjectCustomFormatStringTask = 22262,
        ObjectCustomFormatStringIssue = 22263,
        ObjectCustomFormatStringRoute = 22264,
        ObjectCustomFormatStringReport = 22265,
        ObjectCustomFormatStringSimCard = 22266,
        ObjectCustomFormatStringOperator = 22267,
        ObjectCustomFormatStringDistributor = 22268,
        MarkerCustomFormatStringLocation = 22269,
        MarkerColor = 22270,
        TaskStatusFlow = 17657,
        IssueStatusFlow = 17659,
        PackageStatusFlow = 17810,
        OrderStatusFlow = 17812,
        SSRSCredentials = 12056,
        DataTypeFormatGroup = 10024,
        AllowedDistributors = 17615,
        PageItemsNumber = 22447,
        MapProvider = 22468,
        MxGraphDictionaryRule = 22469,
        MarkerCustomFormatStringTask = 22470,
        ProfileLocationEditForm = 40524
    }

    // #endregion

    // #region SimaxOperatorLayoutSetting

    /**
     * 
     * */
    export enum SimaxOperatorLayoutSetting {
        GridOptions,
        Theme,
        RTL,
        AppState,
        IsMapClustering,
        ImportPlugins,
        FavoriteScripts,
        RecentScripts,
        DXDashboard,
        CashierPanel,
        MassLocationGroupsEdit,
        Import,
        ServicemansSelection,
        Dashboard
        // TODO
    }

    // #endregion

    // #region SimaxLocalStorageKey

    /**
     * 
     * */
    export enum SimaxLocalStorageKey {
        BusinessDictionary = 1,
        CultureName = 2,
        UpdateDate = 3,
        OperatorSettings = 4,
        Login = 5,
        OperatorSession = 6,
        ActiveIdDistributors = 7,
        AppVersion = 8,
        LastIdOperator = 9
    }

    // #endregion

    // #region Stretch

    /**
     * IMR.Suite.Common.Enums
     * */
    export enum Stretch {
        Unknown = 0,
        None = 1,
        Fill = 2,
        Uniform = 3,
        UniformToFill = 4
    }

    // #endregion

    // #region TextAlign

    /**
     * IMR.Suite.Common.Enums
     * */
    export enum TextAlign {
        Default = 0,
        Left = 1,
        Right = 2,
        Center = 3,
        Justify = 4
    }

    // #endregion

    // #region TransmissionType

    /**
     * IMR.Suite.Common.Enums.TransmissionType
     * */
    export enum TransmissionType {
        Unknown = 0,
        Binary = 1,
        Text = 2,
        Text7bit = 3,
        PDUBinary = 4,
        EMail = 5,
        Ring = 6,
        WebService = 7,
    }

    // #endregion

    // #region UIObjectProperties

    /**
     * IMR.Suite.Common.Enums.UIObjectProperties
     * */
    export enum UIObjectProperties {
        DeviceType = 1,
        DeviceStateType = 2,
        DeviceDistributor = 3,
        DeviceDataList = 4,
        TaskFormTaskType = 5,
        TaskGroup = 6,
        TaskPriority = 7,
        TaskPaymentAndPriorityGuidelines = 8,
        TaskIMRMySCVisible = 9,
        TaskIssue = 10,
        TaskOperationCode = 11,
        TaskSalesOrderNumber = 12,
        SimCardCollectingPerson = 13,
        SimCardCollectionDate = 14,
        TaskFitterOrderedToPay = 15,
        TaskFitterPaid = 16,
        TaskFitterPaymentDate = 17,
        TaskClientOrderedToPay = 18,
        TaskClientPaid = 19,
        TaskClientPaymentDate = 20,
        TaskCreationDate = 21,
        TaskDeadline = 22,
        TaskLocation = 23,
        TaskArrangedFitterVisitDate = 24,
        TaskArrangedFitterVisitBeginHour = 25,
        TaskArrangedFitterVisitEndHour = 26,
        TaskPlannedVisitPlanMode = 27,
        TaskPlannedVisitNotes = 28,
        TaskDistributor = 29,
        TaskType = 30,
        TaskStatus = 31,
        TaskStatusNotes = 32,
        TaskOperatorRegistering = 33,
        TaskOperatorPerforming = 34,
        TaskFitterVisitDate = 35,
        TaskValidationDate = 36,
        TaskAdditionalPayment = 37,
        TaskWarrantyService = 38,
        TaskDueDate = 39,
        TaskComplain = 40,
        TaskNotes = 41,
        TaskMaintenanceNotes = 42,
        RoutePointAccomodation = 43,
        TaskSummaryAttachments = 44,
        TaskSummaryPayments = 45,
        TaskSummaryReadoutsView = 46,
        TaskSummaryMapView = 47,
        TaskSummaryLocationEquipment = 48,
        TaskSummaryPlannedVisit = 49,
        RoutePointBaseInformation = 50,
        RoutePointOtherInformation = 51,
        TaskSummaryPoutePoint = 52,
        RoutePointStartDate = 53,
        RoutePointEndDate = 54,
        RoutePointType = 55,
        RoutePointDistributor = 56,
        RoutePointCoordinates = 57,
        RoutePointMileage = 58,
        RoutePointNotes = 59,
        ActionDefId = 60,
        ActionDefDevice = 61,
        ActionDefMeter = 62,
        ActionDefLocation = 63,
        ActionDefDataType = 64,
        ActionDefActionDataId = 65,
        ActionDefActionDataAdd = 66,
        ActionDefActionDataRemove = 67,
        ActionDefActionDataEdit = 68,
        ActionDefActionDataCopy = 69,
        ConfigurationControlDistributors = 70,
        TaskPlannedVisitPlanResult = 71,
        MeasurementEditTemplates = 72,
        LocationSize = 73,
        LocationOperationalCapacity = 74,
        LocationLOLevel = 75,
        LocationLOLOLevel = 76,
        LocationDaysToStockOut = 77,
        LocationNotes = 78,
        LocationIdLocation = 79,
        LocationActor = 80,
        LocationConsumer = 81,
        LocationHostCID = 82,
        DeviceState = 84,
        DevicePattern = 85,
        DeviceWarrantyDate = 86,
        DeviceGeneral = 87,
        DeviceDevices = 88,
        DeviceSchedules = 89,
        DeviceCodes = 90,
        DeviceHistory = 91,
        DeviceHistoryState = 92,
        DeviceHistoryEquipemnt = 93,
        DeviceHistoryHierarchy = 94,
        DeviceOperations = 95,
        DeviceCurrentLocation = 96,
        DeviceDetailsNotePanel = 97,
        DeviceHistoryNotes = 98,
        DeviceAnalogConfiguration = 99,
        DeviceOnSite = 100,
        DeviceProductionConfiguration = 101,
        DeviceSchedulesConfiguration = 102,
        DeviceUdiConfiguration = 103,
        DeviceMeasurements = 104,
        RoutePointDuration = 105,
        LocationPattern = 106,
        LocationImrServer = 107,
        LocationParameters = 108,
        LocationGroups = 109,
        LocationSchedules = 110,
        LocationDevices = 111,
        LocationInstalledDevices = 112,
        LocationInstalledMeters = 113,
        LocationHistory = 114,
        LocationHistoryState = 115,
        LocationHistoryEquipment = 116,
        LocationHistoryIssueTask = 117,
        LocationDevicesAll = 118,
        LocationHistoryStateNotes = 119,
        LocationInstallationParamsGroup = 120,
        LocationInstallationDIParamsGroup = 121,
        LocationInstallationTankParams = 122,
        LocationDistributor = 123,
        LocationAddRemoveDevices = 124,
        LocationAddRemoveMeters = 125,
        IssueHistoryDetails = 126,
        TasksModuleShowSOTAreas = 127,
        TasksModuleShowOperatorsAreas = 128,
        SimCardHistory = 129,
        LocationDataTypePanel = 130,
        TaskLocationPanelParams = 131,
        TaskAdditionalParameters = 132,
        DeviceParameters = 133,
        DeviceParenntDevices = 134,
        DeviceChildDevices = 135,
        MeterHistory = 136,
        MeterParameters = 137,
        DeviceExtendedParameters = 138,
        DistributorParameters = 139,
        TaskParameters = 140,
        IssueParameters = 141,
        IssueAdditionalParameters = 142,
        MeterDevices = 143,
        IssueAttachments = 144,
        TaskAttachments = 145,
        IssueTasks = 146,
        IssueHistory = 147,
        TaskHistory = 148,
        IssueEquipment = 149,
        TaskEquipment = 150,
        OperatorParameters = 151,
        OperatorSignature = 152,
        OperatorAvatar = 153,
        OperatorCarrier = 154,
        AlarmParameters = 155,
        AlarmMap = 156,
        RouteParameters = 157,
        RoutePoints = 158,
        RouteAssignedOperators = 159,
        RouteMap = 160,
        LocationSchema = 161,
        ReportParameters = 162,
        ReportGenereation = 163,
        ActorParameters = 164,
        ActorGroups = 165,
        ActorLocations = 165,
        SimCardParameters = 166,
        ActionParameters = 167,
        LocationGeneralSchema = 168,
        DeviceGeneralSchema = 169,
        MeterGeneralSchema = 170,
        LocationMap = 171,
        LocationExtendedParameters = 172,
        LocationMeasurement = 173,
        AlarmHistory = 174,
        LocationMeasurementPanel = 175,
        MeterAlarmDef = 176,
        MeterAlarmGroup = 177,
        MeterDistributor = 178,
        MeterSerialNbr = 179,
        MeterType = 180,
        MeterProductCode = 181,
        MeterChildOrParent = 182,
        LocationConfigurationProfile = 183,
        ActionHistory = 184,
        AlarmGroupParameters = 185,
        AlarmGroupOperators = 186,
        TaskPayments = 187,
        MeterExtendedParameters = 188,
        AlarmEvents = 189,
        DepositoryParameters = 190,
        DepositoryState = 191,
        ActionPackets = 192,
        LocationLpgKpi = 193,
        MeterLpgKpi = 194,
        TaskModuleMainGrid = 195,
        IssueModuleMainGrid = 196,
        LocationModuleMainGrid = 197,
        DeviceModuleMainGrid = 198,
        MeterModuleMainGrid = 199,
        ActorModuleMainGrid = 200,
        OperatorModuleMainGrid = 201,
        DistributorModuleMainGrid = 202,
        RouteModuleMainGrid = 203,
        AlarmEventModuleMainGrid = 204,
        SimCardModuleMainGrid = 205,
        DepositoryModuleMainGrid = 206,
        ReportModuleMainGrid = 207,
        ActionModuleMainGrid = 208,
        DeviceConnectionModuleMainGrid = 209,
        AlarmGroupModuleMainGrid = 210,
        LPGKpiModuleMainGrid = 211,
        MeterMeasurements = 212,
        AlarmGroup = 213,
        AlarmGroupManiGrid = 214,
        OperatorSecurityEffectivePermission = 215,
        OperatorSecurityRole = 216,
        OperatorSecurityCustomPermission = 217,
        OperatorNotificationIssue = 218,
        OperatorNotificationTask = 219,
        OperatorNotificationRoute = 220,
        OperatorNotificationLocation = 221,
        TaskInstalledEquipment = 222,
        TaskUninstalledEquipment = 223,
        LocationModule = 224,
        DeviceModule = 225,
        MeterModule = 226,
        OperatorModule = 227,
        IssueMoodule = 228,
        TaskModule = 229,
        DistributorModule = 230,
        RouteModule = 231,
        AlarmEventModule = 232,
        SimCardModule = 233,
        ActorModule = 234,
        DepositoryModule = 235,
        ReportModule = 236,
        ActionModule = 237,
        DeviceConnectionModule = 238,
        AlarmDefParams = 239,
        LocationModuleMeasurement = 240,
        MeterModuleMeasurement = 241,
        DeviceModuleMeasurement = 242,
        Dashboard = 243,
        ReportHistory = 244,
        ReportMain = 245,
        GroupingLocationModuleMainGrid = 246,
        GroupingLocationModule = 247,
        GroupingLocationParameters = 248,
        GroupingLocationAssignedLocations = 249,
        GroupingLocationTypeModuleMainGrid = 250,
        GroupingLocationTypeModule = 251,
        DeviceScheduleConfiguration = 252,
        GroupingLocationTypeParameters = 253,
        MeterParametersCurrentDevice = 254,
        ShippingListArticle = 255,
        ShippingListWarranty = 256,
        ShippingListConfiguration = 257,
        ConsumerModule = 258,
        CashierPanel = 259,
        ConsumerParameters = 260,
        ConsumerGroups = 261,
        ConsumerHistory = 262,
        RouteTracking = 263,
        GroupingLocationTypeAssignedLocations = 264,
        ConsumerLocations = 265,
        TaskTypeModule = 266,
        TaskTypeModuleMainGrid = 267,
        TaskTypeParameters = 268,
        ConsumerPayments = 269,
        TariffModule = 270,
        TariffParameters = 271,
        TariffSettlementPeriod = 272,
        TariffLocations = 273,
        OperatorGroupModule = 274,
        OperatorGroupOperators = 275,
        ConsumerNotifications = 276,
        ConsumerModuleMainGrid = 277,
        OperatorGroupParameters = 278,
        TaskTechnicalPermissions = 279,
        TariffModuleMainGrid = 280,
        OperatorTechnicalPermissions = 281,
        ConsumerTypeModuleMainGrid = 282,
        ConsumerTypeParameters = 283,
        DeviceAlarmDef = 284,
        DeviceAlarmGroup = 285,
        OrderModule = 286,
        OrderParameters = 287,
        OrderModuleMainGrid = 288,
        PackageModule = 289,
        PackageParameters = 290,
        PackageModuleMainGrid = 291,
        OrderAssociatedPackages = 292,
        OrderContent = 293,
        OrderHistory = 294,
        PackageAssociatedOrders = 295,
        PackageContent = 296,
        PackageHistory = 297,
        DistributorExtendedParameters = 298,
        DeviceParametersCurrentMeter = 299,
        LocationAlarmDef = 300,
        OperatorGroupTechnicalPermissions = 301,
        DistributorChildDistributors = 302,
        DepositoryMinStates = 303,
        LocationTariff = 304,
        SupplierModule = 305,
        SupplierParameters = 306,
        SupplierLogo = 307,
        SupplierMessages = 308,
        SupplierModuleMainGrid = 309,
        DistributorSuppliers = 310,
    }

    // #endregion

    // #region ValidationErrorCode

    /**
     * IMR.Suite.UI.Business.Objects.Custom.OpValidateInfoMessage.ValidationErrorCode
     * */
    export enum ValidationErrorCode {
        SqlError = 0,
        AccountBlocked = 1,
        InvalidAccountNameOrPassword = 2,
        AccountLoginPermissionDenied = 3,
        MissingParameters = 4,
        ExceptionOccurred = 5,
        InsufficientPermissions = 6,
        UnknownComponent = 7,
        InitializationError = 8,
        IdsNotMapped = 9,
        ServerNotFound = 10,
        MSMQParamsNotFound = 11,
        InvalidLocation = 12,
        LocationCidAlreadyExists = 13
    }

    // #endregion

    // #region ValidationStatus

    /**
     * IMR.Suite.Common.Enums.ValidationStatus
     * */
    export enum ValidationStatus {
        Unknown = 0,
        Correct = 1,
        Incorrect = 2,
        Warning = 3
    }

    // #endregion

    // #region ViewColumnType

    /**
     * IMR.Suite.Common.Enums.ViewColumnType
     * */
    export enum ViewColumnType {
        Unknown = 0,
        Standard = 1,
        BaseHelper = 2,
        ExtendedHelper = 3
    }

    // #endregion

    // #region ValveState

    /**
     * IMR.Suite.Common.Enums.ValveState
     * */
    export enum ValveState {
        Closed = 0, //VALVE_LOGICAL_CLOSE
        Opened = 1, //VALVE_LOGICAL_OPEN    
        LeakTestInProgress = 2,
        ValveIsClosing = 3,
        ValveIsOpening = 4,
        WaitingForOpen = 16,
        WaitingForClose = 32,
        //New WAN3 64 + n
        ClosedWaitingForConfirmOpen = 65, //VALVE_LOGICAL_CLOSE_CONFIRM_OPEN 
        OpenedLeakTestInProgress = 66, //VALVE_LOGICAL_OPEN_LEAK_TEST
        ClosedUnsuccessfulOpen = 67, //VALVE_LOGICAL_CLOSE_UNSUCCESSFUL_OPEN
        Unknown = 255,
    }

    // #endregion

    // #region WebSimaxModule

    export enum WebSimaxModule {
        Unknown = 0,
        Actions = 1,
        Actors = 2,
        AlarmGroups = 3,
        AlarmEvents = 4,
        CashierPanel = 5,
        ConsumerTypes = 6,
        Consumers = 7,
        Dashboard = 8,
        Depositories = 9,
        DeviceConnections = 10,
        Devices = 11,
        Distributors = 12,
        DxDashboard = 13,
        GroupingLocations = 14,
        GroupingLocationsTypes = 15,
        Issues = 16,
        Kpi = 17,
        Locations = 18,
        Login = 19,
        Meters = 20,
        OperatorGroups = 21,
        Operators = 22,
        Orders = 23,
        Packages = 24,
        Reports = 25,
        Routes = 26,
        Scripts = 27,
        Settings = 28,
        SimCards = 29,
        Tariffs = 30,
        Tasks = 31,
        TasksTypes = 32
    }

    // #endregion

    // #region WeekDay

    /**
     * IMR.Suite.Common.Enums.WeekDay
     * */
    export enum WeekDay {
        Unknown = 0,
        Sunday = 1,
        Monday = 2,
        Tuesday = 3,
        Wednesday = 4,
        Thursday = 5,
        Friday = 6,
        Saturday = 7,
        All = 255,
    }

    // #endregion

    // #region WorkType

    /**
     * IMR.Suite.Common.Enums.WorkType
     * */
    export enum WorkType {
        //WorkItem
        PeriodicWork = 0,
        TaskSuspension = 1,
        DevicesObservation = 2,
        FileCleaner = 3,
        WarrantyDevicesUnmountedReminder = 4,
        DeviceBatchNumberImport = 5,
        DeviceInvoice = 6,
        ServiceReport = 7,
        DeviceProductionOrderNumberImport = 8,
        DeviceSimCardHistoryCreate = 9,//ID_REFERENCE_TYPE, (lista dystrybutorów albo numerów seryjnych)
        DeviceActivationTimeCompute = 10,
        PerformanceAggregateCompute = 11,
        PerformanceReport = 12,
        PerformanceNotifications = 13,
        PerformanceBaseCompute = 14,

        SimCardInformationSynchronize = 20,
        DeviceWarrantyCompute = 21,
        TaskNotification = 22,
        WarrantyDevicesInstallationDateCompute = 23,
        DeviceScheduleCompute = 24,
        DeviceProductionSynchronization = 25,
        FaultCodeSummaryCompute = 26,
        DeviceLeadingDataTypeCompute = 27,
        IssueGenerator = 28,
        TaskExportActionCheck = 29,
        TaskStatusChange = 30,
        TestEmail = 31,
        SITADBGenerate = 32,
        WatermeterLocationImport = 33,
        SimCardImport = 34,
        wTPMediaLocationImport = 35,
        wTPMediaRouteImport = 36,
        wTPMediaRouteExport = 37,
        wViewsManagerController = 38,
        wContactImport = 39,

        wEVADBGenerator = 40,
        wInstallationTaskPhotoPin = 41,
        wLocationImport = 42,
        wDeviceImport = 43,
        wDeviceShippingImport = 44,
        wUskomRouteExport = 45,
        wImportMeter = 46,
        wTankMeterImport = 47,
        wDeviceShippingExport = 48,
        wChrostkowoRouteExport = 49,
        wGasLocationImport = 50,
        wZWiKSulecinRouteExport = 51,
        wGasmeterProductionOCR = 52,
        wIssueParser = 53,
        wUskomLocationExport = 54,

        //LocationCollector > 1000
        Collector = 1000,
        CollectorSynchronizeData = 1001//czas w minutach pomiędzy kolejnymi wywolaniami, ID serwara z tabelki IMR_SERVER, kod zadania Work
    }

    // #endregion
}

// #endregion

// #region LEGACY - DEPRECATED

// !!! Te enum są już nie używane. Użyj module Enums.


// #region FileExtension

/**
 * @deprecated Use Enums.FileExtension
 * */
export enum FileExtension {
    Unknown = 0,
    Pdf = 1,
    Xlsx = 2,
    Xls = 3,
    Csv = 4,
    Jpg = 5,
    Png = 6,
    Bmp = 7,
    Log = 8,
    Sql = 9,
    Rtf = 10,
    Svg = 11,
    // Custom
    Jpeg = 100
}

// #endregion

// #region OpChangeState

/**
 * IMR.Suite.UI.Business.Objects.IOpChangeState
 * @deprecated Use Enums.IOpChangeState
 * */
export enum OpChangeState {
    Undefined = 0,
    New = 1,
    Modified = 2,
    Loaded = 3,
    Delete = 4,
    Incorrect = 5,
}

// #endregion

// #region ReferenceType

/**
 * IMR.Suite.Common.Enums.ReferenceType
 * @deprecated Use Enums.ReferenceType
 * */
export enum ReferenceType {
    None = 0,
    IdOperator = 1,
    IdAtgType = 2,
    IdReport = 3,
    IdReportDataType = 4,
    IdDataType = 5,
    SerialNbr = 6,
    IdMeter = 7,
    IdLocation = 8,
    IdProductCode = 9,
    IdDeviceDriver = 10,
    IdDistributor = 11,
    IdDelivery = 12,
    IdMeterType = 13,
    IdDeviceType = 14,
    IdValveState = 15,
    IdIssueStatus = 16,
    IdIssueType = 17,
    IdTaskStatus = 18,
    IdTaskType = 19,
    IdRoute = 20,
    IdRouteStatus = 21,
    IdRole = 22,
    /// <summary>
    /// Lista ID_OPERATOR podawana jako string: 1;2;45;678
    /// </summary>
    OperatorList = 23,
    /// <summary>
    /// dopisać do DB, podawana jako nazwa typu akcji w formacie SMS_GET_DATA
    /// </summary>
    ActionType = 24,
    IdLanguage = 25,
    IdIMRServer = 26,
    IdFile = 27,
    IdDataSourceType = 28,
    IdActionDef = 29,
    IdProfile = 30,
    IdSlotType = 31,
    IdDetailView = 32,
    IdModule = 33,
    IdActivity = 34,
    IdCommandCodeType = 35,
    IdActionSmsText = 36,
    IdDepot = 37,
    IdDeliveryAdvice = 38,
    IdLocationStateType = 39,
    IdLocationType = 40,
    IdAggregationType = 41,
    IdConfigurationProfile = 42,
    IdTariff = 43,
    IdWMBUSTransmissionType = 44,
    IdMeterTypeGroup = 45,
    IdDescr = 46,
    IdSupplier = 47,
    IdAlarmText = 48,
    IdDeviceDashboardMainChartView = 49,
    IdDeviceDashboardAdditionalChartView = 50,
    IdMeterTypeClass = 51,
    IdFileExtension = 52,
    IdDeviceStateType = 53,
    /// <summary>
    /// Lista ID_TASK_STATUS podawana jako string: 1;2;45;678
    /// </summary>
    TaskStatusList = 54,
    IdGross = 55,
    IdNet = 56,
    IdReportType = 57,
    IdFaultCode = 58,
    IdTransmissionType = 59,
    IdUIObjectProperties = 60,
    IdDataFormatGroup = 61,
    IdArticle = 62,
    IdTaskGroup = 63,
    IdFileType = 64,
    IdIssue = 65,
    IdTask = 66,
    IdReferenceType = 67,
    IdMapMarkerTextType = 68,
    IdTransmissionDriver = 69,
    IdSimCard = 70,
    SITAUIObjectProperties = 71,
    IdVersion = 72,
    IdActor = 73,
    IdDeviceTypeGroup = 74,
    IdEtl = 75,
    IdOperatorLoginStatus = 76,
    TextValue = 77,
    IdDepositoryElement = 78,
    IdDeviceOrderNumber = 79,
    IdRefuel = 80,
    IdUnit = 81,
    IdSitaCommandType = 82,
    IdEmailSendingMode = 83,
    IdVersionState = 84,
    IdIssueGroup = 85,
    IdPriority = 86,
    IdSitaFitterDeposiotryMode = 87,
    IdAlarm = 88,
    IdAlarmGroup = 89,
    IdAlarmStatus = 90,
    IdRouteType = 91,
    IdRouteDef = 92,
    IdChartType = 93,
    IdView = 94,
    IdAlarmType = 95,
    IdAlarmDef = 96,
    IdDataArch = 97,
    IdFuelFillingPointType = 98,
    IdDispenserPumpType = 99,
    IdStationType = 100,
    IdStationProfileType = 101,
    IdAction = 102,
    IdActorGroup = 103,
    IdVersionElement = 104,
    IdViewColumn = 105,
    IdProtocol = 106,
    IdActionStatus = 107,
    IdDatabaseType = 108,
    LocationList = 109,
    IdDeviceInstalationPlace = 110,
    IdDeviceLocationCompassDirection = 111,
    IdDeviceConnection = 112,
    IdSitaInstallationFormType = 113,
    IdAlarmEvent = 114,
    DistributorList = 115,
    MeterTypeList = 116,
    DeviceTypeList = 117,
    AreaList = 118,
    IdDataTypeGroup = 119,
    IdDataTypeInGroup = 120,
    IdTaskTypeGroup = 121,
    IdCurrency = 122,
    IdPackage = 123,
    IdPackageStatus = 124,
    Color = 125,
    IdReportScheduleMode = 126,
    IdGridOption = 127,
    IdDeviceTypeInstallationWay = 128,
    IdMobileNetworkCode = 129,

    IdDistributorHierarchy = 140,

    IdMapProvider = 173,

    IdLocationFieldElement = 196,
    IdLocationProjectType = 197
}

// #endregion

// #region UIObjectProperties

/**
 * IMR.Suite.Common.Enums.UIObjectProperties
 * @deprecated Use Enums.UIObjectProperties
 * */
export enum UIObjectProperties {
    DeviceType = 1,
    DeviceStateType = 2,
    DeviceDistributor = 3,
    DeviceDataList = 4,
    TaskFormTaskType = 5,
    TaskGroup = 6,
    TaskPriority = 7,
    TaskPaymentAndPriorityGuidelines = 8,
    TaskIMRMySCVisible = 9,
    TaskIssue = 10,
    TaskOperationCode = 11,
    TaskSalesOrderNumber = 12,
    SimCardCollectingPerson = 13,
    SimCardCollectionDate = 14,
    TaskFitterOrderedToPay = 15,
    TaskFitterPaid = 16,
    TaskFitterPaymentDate = 17,
    TaskClientOrderedToPay = 18,
    TaskClientPaid = 19,
    TaskClientPaymentDate = 20,
    TaskCreationDate = 21,
    TaskDeadline = 22,
    TaskLocation = 23,
    TaskArrangedFitterVisitDate = 24,
    TaskArrangedFitterVisitBeginHour = 25,
    TaskArrangedFitterVisitEndHour = 26,
    TaskPlannedVisitPlanMode = 27,
    TaskPlannedVisitNotes = 28,
    TaskDistributor = 29,
    TaskType = 30,
    TaskStatus = 31,
    TaskStatusNotes = 32,
    TaskOperatorRegistering = 33,
    TaskOperatorPerforming = 34,
    TaskFitterVisitDate = 35,
    TaskValidationDate = 36,
    TaskAdditionalPayment = 37,
    TaskWarrantyService = 38,
    TaskDueDate = 39,
    TaskComplain = 40,
    TaskNotes = 41,
    TaskMaintenanceNotes = 42,
    RoutePointAccomodation = 43,
    TaskSummaryAttachments = 44,
    TaskSummaryPayments = 45,
    TaskSummaryReadoutsView = 46,
    TaskSummaryMapView = 47,
    TaskSummaryLocationEquipment = 48,
    TaskSummaryPlannedVisit = 49,
    RoutePointBaseInformation = 50,
    RoutePointOtherInformation = 51,
    TaskSummaryPoutePoint = 52,
    RoutePointStartDate = 53,
    RoutePointEndDate = 54,
    RoutePointType = 55,
    RoutePointDistributor = 56,
    RoutePointCoordinates = 57,
    RoutePointMileage = 58,
    RoutePointNotes = 59,
    ActionDefId = 60,
    ActionDefDevice = 61,
    ActionDefMeter = 62,
    ActionDefLocation = 63,
    ActionDefDataType = 64,
    ActionDefActionDataId = 65,
    ActionDefActionDataAdd = 66,
    ActionDefActionDataRemove = 67,
    ActionDefActionDataEdit = 68,
    ActionDefActionDataCopy = 69,
    ConfigurationControlDistributors = 70,
    TaskPlannedVisitPlanResult = 71,
    MeasurementEditTemplates = 72,
    LocationSize = 73,
    LocationOperationalCapacity = 74,
    LocationLOLevel = 75,
    LocationLOLOLevel = 76,
    LocationDaysToStockOut = 77,
    LocationNotes = 78,
    LocationIdLocation = 79,
    LocationActor = 80,
    LocationConsumer = 81,
    LocationHostCID = 82,
    DeviceState = 84,
    DevicePattern = 85,
    DeviceWarrantyDate = 86,
    DeviceGeneral = 87,
    DeviceDevices = 88,
    DeviceSchedules = 89,
    DeviceCodes = 90,
    DeviceHistory = 91,
    DeviceHistoryState = 92,
    DeviceHistoryEquipemnt = 93,
    DeviceHistoryHierarchy = 94,
    DeviceOperations = 95,
    DeviceCurrentLocation = 96,
    DeviceDetailsNotePanel = 97,
    DeviceHistoryNotes = 98,
    DeviceAnalogConfiguration = 99,
    DeviceOnSite = 100,
    DeviceProductionConfiguration = 101,
    DeviceSchedulesConfiguration = 102,
    DeviceUdiConfiguration = 103,
    DeviceMeasurements = 104,
    RoutePointDuration = 105,
    LocationPattern = 106,
    LocationImrServer = 107,
    LocationParameters = 108,
    LocationGroups = 109,
    LocationSchedules = 110,
    LocationDevices = 111,
    LocationInstalledDevices = 112,
    LocationInstalledMeters = 113,
    LocationHistory = 114,
    LocationHistoryState = 115,
    LocationHistoryEquipment = 116,
    LocationHistoryIssueTask = 117,
    LocationDevicesAll = 118,
    LocationHistoryStateNotes = 119,
    LocationInstallationParamsGroup = 120,
    LocationInstallationDIParamsGroup = 121,
    LocationInstallationTankParams = 122,
    LocationDistributor = 123,

    LocationAddRemoveDevices = 124,
    LocationAddRemoveMeters = 125,
    IssueHistoryDetails = 126,
    TasksModuleShowSOTAreas = 127,
    TasksModuleShowOperatorsAreas = 128,
    SimCardHistory = 129,
    LocationDataTypePanel = 130,
    TaskLocationPanelParams = 131,
    TaskAdditionalParameters = 132,
    DeviceParameters = 133,
    DeviceParenntDevices = 134,
    DeviceChildDevices = 135,
    MeterHistory = 136,
    MeterParameters = 137,
    DeviceExtendedParameters = 138,
    DistributorParameters = 139,
    TaskParameters = 140,
    IssueParameters = 141,
    IssueAdditionalParameters = 142,
    MeterDevices = 143,
    IssueAttachments = 144,
    TaskAttachments = 145,
    IssueTasks = 146,
    IssueHistory = 147,
    TaskHistory = 148,
    IssueEquipment = 149,
    TaskEquipment = 150,
    OperatorParameters = 151,
    OperatorSignature = 152,
    OperatorAvatar = 153,
    OperatorCarrier = 154,
    AlarmParameters = 155,
    AlarmMap = 156,
    RouteParameters = 157,
    RoutePoints = 158,
    RouteAssignedOperators = 159,
    RouteMap = 160,
    LocationSchema = 161,
    ReportParameters = 162,
    ReportGenereation = 163,
    ActorParameters = 164,
    ActorGroups = 165,
    ActorLocations = 165,
    SimCardParameters = 166,
    ActionParameters = 167,
    LocationGeneralSchema = 168,
    DeviceGeneralSchema = 169,
    MeterGeneralSchema = 170,
    LocationMap = 171,
    LocationExtendedParameters = 172,
    LocationMeasurement = 173,
    AlarmHistory = 174,
    LocationMeasurementPanel = 175,
    MeterAlarmDef = 176,
    MeterAlarmGroup = 177,
    MeterDistributor = 178,
    MeterSerialNbr = 179,
    MeterType = 180,
    MeterProductCode = 181,
    MeterChildOrParent = 182,
    LocationConfigurationProfile = 183,
    ActionHistory = 184,
    AlarmGroupParameters = 185,
    AlarmGroupOperators = 186,
    TaskPayments = 187,
    MeterExtendedParameters = 188,
    AlarmEvents = 189,
    DepositoryParameters = 190,
    DepositoryState = 191,
    ActionPackets = 192,
    LocationLpgKpi = 193,
    MeterLpgKpi = 194,
    TaskModuleMainGrid = 195,
    IssueModuleMainGrid = 196,
    LocationModuleMainGrid = 197,
    DeviceModuleMainGrid = 198,
    MeterModuleMainGrid = 199,
    ActorModuleMainGrid = 200,
    OperatorModuleMainGrid = 201,
    DistributorModuleMainGrid = 202,
    RouteModuleMainGrid = 203,
    AlarmEventModuleMainGrid = 204,
    SimCardModuleMainGrid = 205,
    DepositoryModuleMainGrid = 206,
    ReportModuleMainGrid = 207,
    ActionModuleMainGrid = 208,
    DeviceConnectionModuleMainGrid = 209,
    AlarmGroupModuleMainGrid = 210,
    LPGKpiModuleMainGrid = 211,
    MeterMeasurements = 212,
    AlarmGroup = 213,
    OperatorSecurityEffectivePermission = 215,
    OperatorSecurityRole = 216,
    OperatorSecurityCustomPermission = 217,
    OperatorNotificationIssue = 218,
    OperatorNotificationTask = 219,
    OperatorNotificationRoute = 220,
    OperatorNotificationLocation = 221,
    TaskInstalledEquipment = 222,
    TaskUninstalledEquipment = 223,
    LocationModule = 224,
    DeviceModule = 225,
    MeterModule = 226,
    OperatorModule = 227,
    IssueMoodule = 228,
    TaskModule = 229,
    DistributorModule = 230,
    RouteModuule = 231,
    AlarmEventModule = 232,
    SimCardModule = 233,
    ActorModule = 234,
    DepositoryModule = 235,
    ReportModule = 236,
    ActionModule = 237,
    DeviceConnectionModule = 238,
    AlarmDefParams = 239,

    ReportHistory = 244,
    ReportMain = 245,

}

// #endregion

// #endregion

// Zachować kolejność alfabetyczną dodając nowe enum
// Enum powinien dokładnie odwzorowywać swój odpowiednik z pliku Enums.cs z projektu Common
// Jeśli istnieją uzasadnione przypadki, w których trzeba stworzyć enum lokalnie ma rozpoczynać się przedrostkiem Simax
// Enum'y poza modulem Enums są deprecated i powinny zostać sukcesywanie usuwane
